var _defs, _path, _g, _g2, _g3, _path2, _g4, _g5, _g6, _g7, _path3, _line, _polyline, _polyline2, _polyline3, _polyline4, _polyline5, _polyline6, _clipPath, _path4, _line2, _polyline7, _polyline8, _polyline9, _polyline10, _polyline11, _polyline12, _clipPath2, _path5, _line3, _polyline13, _polyline14, _polyline15, _polyline16, _polyline17, _polyline18, _clipPath3, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _path6, _path7, _polygon12, _g8, _path8, _path9, _path10, _path11, _g9, _path12, _g10, _g11, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _polygon25, _polygon26, _polygon27, _polygon28, _polygon29, _polygon30, _polygon31, _polygon32, _path13, _g12, _path14, _g13, _g14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _g15, _path30, _line4, _polyline19, _polyline20, _polyline21, _polyline22, _polyline23, _polyline24, _clipPath4, _path31, _line5, _polyline25, _polyline26, _polyline27, _polyline28, _polyline29, _polyline30, _clipPath5, _path32, _line6, _polyline31, _polyline32, _polyline33, _polyline34, _polyline35, _polyline36, _clipPath6, _g16, _path33, _path34, _g17;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeImage1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eSvLbpigY9t1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t78-fill",
    x1: 325.77,
    y1: 246,
    x2: 294.13,
    y2: 192.23,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t78-fill-0",
    offset: "0%",
    stopColor: "#f7f7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t78-fill-1",
    offset: "100%",
    stopColor: "#bebee0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t79-fill",
    x1: 294.68,
    y1: 258.69,
    x2: 258.07,
    y2: 175.07,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t79-fill-0",
    offset: "0%",
    stopColor: "#f7f7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t79-fill-1",
    offset: "100%",
    stopColor: "#bebee0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t87-fill",
    x1: 299.995928,
    y1: 176.75693,
    x2: 301.778458,
    y2: 120.65751,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t87-fill-0",
    offset: "0%",
    stopColor: "#346d4d"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t87-fill-1",
    offset: "100%",
    stopColor: "#8ac45e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t103-fill",
    x1: 313.544918,
    y1: 189.57501,
    x2: 347.129496,
    y2: 150.024951,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t103-fill-0",
    offset: "0%",
    stopColor: "#346d4d"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t103-fill-1",
    offset: "100%",
    stopColor: "#8ac45e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t117-fill",
    x1: 279.363849,
    y1: 182.128849,
    x2: 242.395016,
    y2: 145.954216,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t117-fill-0",
    offset: "0%",
    stopColor: "#346d4d"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t117-fill-1",
    offset: "100%",
    stopColor: "#8ac45e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t149-fill",
    x1: 233.1,
    y1: 122.37,
    x2: 215.19,
    y2: 199.59,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t149-fill-0",
    offset: "0%",
    stopColor: "#405078"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t149-fill-1",
    offset: "100%",
    stopColor: "#252e45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t174-fill",
    x1: 264.63,
    y1: 184.11,
    x2: 220.48,
    y2: 148.87,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t174-fill-0",
    offset: "0%",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t174-fill-1",
    offset: "100%",
    stopColor: "#cecfdb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t176-fill",
    x1: 273.17,
    y1: 149.58,
    x2: 213.4,
    y2: 181.88,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t176-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t176-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t177-fill",
    x1: 269.93,
    y1: 145.51,
    x2: 210.84,
    y2: 177.45,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t177-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t177-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t178-fill",
    x1: 269.96,
    y1: 145.43,
    x2: 210.83,
    y2: 177.39,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t178-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t178-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t179-fill",
    x1: 269.97,
    y1: 145.36,
    x2: 210.83,
    y2: 177.32,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t179-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t179-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t180-fill",
    x1: 271.59,
    y1: 147.23,
    x2: 211.84,
    y2: 179.52,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t180-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t180-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t181-fill",
    x1: 271.61,
    y1: 147.16,
    x2: 211.88,
    y2: 179.44,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t181-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t181-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t182-fill",
    x1: 269.96,
    y1: 145.31,
    x2: 210.84,
    y2: 177.25,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t182-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t182-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t183-fill",
    x1: 273.12,
    y1: 149.73,
    x2: 213.31,
    y2: 182.05,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t183-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t183-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t184-fill",
    x1: 274.49,
    y1: 152.37,
    x2: 214.8,
    y2: 184.62,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t184-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t184-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t185-fill",
    x1: 271.63,
    y1: 147.09,
    x2: 211.93,
    y2: 179.35,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t185-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t185-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t186-fill",
    x1: 269.95,
    y1: 145.25,
    x2: 210.85,
    y2: 177.19,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t186-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t186-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t187-fill",
    x1: 273.15,
    y1: 149.65,
    x2: 213.35,
    y2: 181.97,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t187-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t187-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t188-fill",
    x1: 274.56,
    y1: 152.26,
    x2: 214.82,
    y2: 184.55,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t188-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t188-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t189-fill",
    x1: 269.98,
    y1: 145.17,
    x2: 210.85,
    y2: 177.12,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t189-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t189-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t190-fill",
    x1: 275.97,
    y1: 154.81,
    x2: 216.26,
    y2: 187.08,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t190-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t190-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t191-fill",
    x1: 274.59,
    y1: 152.19,
    x2: 214.86,
    y2: 184.46,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t191-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t191-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t192-fill",
    x1: 271.2,
    y1: 147.22,
    x2: 212.05,
    y2: 179.19,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t192-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t192-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t193-fill",
    x1: 276.04,
    y1: 154.71,
    x2: 216.28,
    y2: 187.01,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t193-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t193-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t194-fill",
    x1: 269.93,
    y1: 145.13,
    x2: 210.86,
    y2: 177.05,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t194-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t194-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t195-fill",
    x1: 272.81,
    y1: 149.68,
    x2: 213.52,
    y2: 181.73,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t195-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t195-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t196-fill",
    x1: 271.69,
    y1: 146.86,
    x2: 212.04,
    y2: 179.1,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t196-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t196-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t197-fill",
    x1: 275.66,
    y1: 154.82,
    x2: 216.48,
    y2: 186.8,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t197-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t197-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t198-fill",
    x1: 274.1,
    y1: 152.34,
    x2: 215.05,
    y2: 184.25,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t198-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t198-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t199-fill",
    x1: 273.23,
    y1: 149.37,
    x2: 213.51,
    y2: 181.64,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t199-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t199-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t200-fill",
    x1: 277.53,
    y1: 157.08,
    x2: 217.83,
    y2: 189.35,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t200-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t200-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t201-fill",
    x1: 276.11,
    y1: 154.48,
    x2: 216.4,
    y2: 186.75,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t201-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t201-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t202-fill",
    x1: 274.63,
    y1: 151.95,
    x2: 215,
    y2: 184.17,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t202-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t202-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t203-fill",
    x1: 276.1,
    y1: 154.42,
    x2: 216.45,
    y2: 186.66,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t203-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t203-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t204-fill",
    x1: 277.56,
    y1: 156.93,
    x2: 217.91,
    y2: 189.17,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t204-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t204-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t205-fill",
    x1: 277.57,
    y1: 156.99,
    x2: 217.86,
    y2: 189.26,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t205-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t205-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t206-fill",
    x1: 277.57,
    y1: 157.12,
    x2: 217.76,
    y2: 189.45,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t206-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t206-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t207-fill",
    x1: 277.49,
    y1: 157.23,
    x2: 217.74,
    y2: 189.52,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t207-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t207-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t208-fill",
    x1: 274.35,
    y1: 152.69,
    x2: 214.67,
    y2: 184.94,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t208-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t208-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t209-fill",
    x1: 275.68,
    y1: 155.47,
    x2: 215.98,
    y2: 187.73,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t209-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t209-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t210-fill",
    x1: 274.11,
    y1: 153.15,
    x2: 214.85,
    y2: 185.18,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t210-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t210-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t211-fill",
    x1: 272.66,
    y1: 150.62,
    x2: 213.16,
    y2: 182.77,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t211-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t211-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t212-fill",
    x1: 277.06,
    y1: 158.15,
    x2: 217.55,
    y2: 190.31,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t212-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t212-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t213-fill",
    x1: 269.91,
    y1: 146.02,
    x2: 210.81,
    y2: 177.96,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t213-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t213-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t214-fill",
    x1: 271.23,
    y1: 147.99,
    x2: 211.55,
    y2: 180.24,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t214-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t214-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t215-fill",
    x1: 272.74,
    y1: 150.5,
    x2: 212.98,
    y2: 182.8,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t215-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t215-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t216-fill",
    x1: 269.92,
    y1: 145.95,
    x2: 210.78,
    y2: 177.91,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t216-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t216-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t217-fill",
    x1: 269.92,
    y1: 145.89,
    x2: 210.8,
    y2: 177.84,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t217-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t217-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t218-fill",
    x1: 269.93,
    y1: 145.82,
    x2: 210.8,
    y2: 177.78,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t218-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t218-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t219-fill",
    x1: 269.92,
    y1: 145.76,
    x2: 210.82,
    y2: 177.7,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t219-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t219-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t220-fill",
    x1: 271.37,
    y1: 147.66,
    x2: 211.69,
    y2: 179.92,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t220-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t220-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t221-fill",
    x1: 271.36,
    y1: 147.73,
    x2: 211.62,
    y2: 180.02,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t221-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t221-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t222-fill",
    x1: 271.32,
    y1: 147.82,
    x2: 211.6,
    y2: 180.09,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t222-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t222-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t223-fill",
    x1: 271.29,
    y1: 147.9,
    x2: 211.54,
    y2: 180.18,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t223-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t223-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t224-fill",
    x1: 272.79,
    y1: 150.41,
    x2: 212.97,
    y2: 182.73,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t224-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t224-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t225-fill",
    x1: 274.21,
    y1: 153.01,
    x2: 214.53,
    y2: 185.27,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t225-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t225-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t226-fill",
    x1: 275.57,
    y1: 155.63,
    x2: 216.42,
    y2: 187.59,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t226-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t226-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t227-fill",
    x1: 274.26,
    y1: 152.92,
    x2: 214.51,
    y2: 185.21,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t227-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t227-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t228-fill",
    x1: 273.04,
    y1: 149.84,
    x2: 213.29,
    y2: 182.13,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t228-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t228-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t229-fill",
    x1: 269.94,
    y1: 145.69,
    x2: 210.81,
    y2: 177.64,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t229-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t229-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t230-fill",
    x1: 269.94,
    y1: 145.63,
    x2: 210.82,
    y2: 177.58,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t230-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t230-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t231-fill",
    x1: 271.46,
    y1: 147.49,
    x2: 211.74,
    y2: 179.76,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t231-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t231-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t232-fill",
    x1: 272.99,
    y1: 149.99,
    x2: 213.19,
    y2: 182.3,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t232-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t232-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t233-fill",
    x1: 269.97,
    y1: 145.55,
    x2: 210.81,
    y2: 177.52,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t233-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t233-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t234-fill",
    x1: 271.55,
    y1: 147.38,
    x2: 211.74,
    y2: 179.7,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t234-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t234-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t235-fill",
    x1: 273.08,
    y1: 149.88,
    x2: 213.2,
    y2: 182.24,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t235-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t235-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t236-fill",
    x1: 272.83,
    y1: 150.32,
    x2: 213.03,
    y2: 182.64,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t236-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t236-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t237-fill",
    x1: 272.87,
    y1: 150.24,
    x2: 213.07,
    y2: 182.56,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t237-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t237-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t238-fill",
    x1: 274.29,
    y1: 152.85,
    x2: 214.57,
    y2: 185.12,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t238-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t238-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t239-fill",
    x1: 271.44,
    y1: 147.56,
    x2: 211.69,
    y2: 179.85,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t239-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t239-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t240-fill",
    x1: 275.73,
    y1: 155.38,
    x2: 215.97,
    y2: 187.68,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t240-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t240-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t241-fill",
    x1: 272.89,
    y1: 150.16,
    x2: 213.13,
    y2: 182.46,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t241-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t241-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t242-fill",
    x1: 274.33,
    y1: 152.76,
    x2: 214.6,
    y2: 185.04,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t242-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t242-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t243-fill",
    x1: 275.76,
    y1: 155.3,
    x2: 216.02,
    y2: 187.59,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t243-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t243-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t244-fill",
    x1: 277.19,
    y1: 157.88,
    x2: 217.45,
    y2: 190.16,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t244-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t244-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t245-fill",
    x1: 272.96,
    y1: 150.06,
    x2: 213.14,
    y2: 182.39,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t245-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t245-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t246-fill",
    x1: 275.8,
    y1: 155.21,
    x2: 216.05,
    y2: 187.51,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t246-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t246-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t247-fill",
    x1: 277.23,
    y1: 157.8,
    x2: 217.48,
    y2: 190.09,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t247-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t247-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t248-fill",
    x1: 274.41,
    y1: 152.59,
    x2: 214.67,
    y2: 184.88,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t248-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t248-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t249-fill",
    x1: 275.83,
    y1: 155.14,
    x2: 216.12,
    y2: 187.41,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t249-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t249-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t250-fill",
    x1: 274.44,
    y1: 152.51,
    x2: 214.72,
    y2: 184.79,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t250-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t250-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t251-fill",
    x1: 275.88,
    y1: 155.04,
    x2: 216.13,
    y2: 187.34,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t251-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t251-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t252-fill",
    x1: 274.52,
    y1: 152.41,
    x2: 214.72,
    y2: 184.73,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t252-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t252-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t253-fill",
    x1: 275.92,
    y1: 154.96,
    x2: 216.17,
    y2: 187.25,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t253-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t253-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t254-fill",
    x1: 276,
    y1: 154.86,
    x2: 216.17,
    y2: 187.19,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t254-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t254-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t255-fill",
    x1: 276.91,
    y1: 157.75,
    x2: 218.15,
    y2: 189.51,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t255-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t255-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t256-fill",
    x1: 277.11,
    y1: 158.05,
    x2: 217.41,
    y2: 190.31,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t256-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t256-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t257-fill",
    x1: 277.16,
    y1: 157.96,
    x2: 217.39,
    y2: 190.26,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t257-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t257-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t258-fill",
    x1: 269.9,
    y1: 146.09,
    x2: 210.82,
    y2: 178.02,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t258-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t258-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t259-fill",
    x1: 271.19,
    y1: 148.08,
    x2: 211.54,
    y2: 180.32,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t259-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t259-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t260-fill",
    x1: 271.5,
    y1: 147.34,
    x2: 211.83,
    y2: 179.59,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t260-fill-0",
    offset: "0%",
    stopColor: "#333e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t260-fill-1",
    offset: "100%",
    stopColor: "#222931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t261-fill",
    x1: 279.78,
    y1: 153.91,
    x2: 247.69,
    y2: 186.33,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t261-fill-0",
    offset: "0%",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t261-fill-1",
    offset: "100%",
    stopColor: "#cecfdb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t303-fill",
    x1: 272.45,
    y1: 159.93,
    x2: 271.71,
    y2: 162.32,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t303-fill-0",
    offset: "0%",
    stopColor: "#fdddc8"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t303-fill-1",
    offset: "100%",
    stopColor: "#f8b4a8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t304-fill",
    x1: 269.66,
    y1: 160.95,
    x2: 268.51,
    y2: 165.2,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t304-fill-0",
    offset: "0%",
    stopColor: "#fdddc8"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t304-fill-1",
    offset: "100%",
    stopColor: "#f8b4a8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t305-fill",
    x1: 267.57,
    y1: 161.92,
    x2: 265.55,
    y2: 167.52,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t305-fill-0",
    offset: "0%",
    stopColor: "#fdddc8"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t305-fill-1",
    offset: "100%",
    stopColor: "#f8b4a8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t307-fill",
    x1: 317.78,
    y1: 178.07,
    x2: 333.08,
    y2: 175.92,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t307-fill-0",
    offset: "0%",
    stopColor: "#fbd1be"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t307-fill-1",
    offset: "100%",
    stopColor: "#f8b4a8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t309-fill",
    x1: 269.51,
    y1: 170.4,
    x2: 275.75,
    y2: 169.52,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t309-fill-0",
    offset: "0%",
    stopColor: "#fbd1be"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t309-fill-1",
    offset: "100%",
    stopColor: "#f8b4a8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t313-fill",
    x1: 314.75,
    y1: 161.41,
    x2: 340.49,
    y2: 144.96,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t313-fill-0",
    offset: "0%",
    stopColor: "#fbd1be"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t313-fill-1",
    offset: "100%",
    stopColor: "#f8b4a8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t320-fill",
    x1: 245.64,
    y1: 180.81,
    x2: 251.21,
    y2: 180.03,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t320-fill-0",
    offset: "0%",
    stopColor: "#fbd1be"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t320-fill-1",
    offset: "100%",
    stopColor: "#f8b4a8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t336-fill",
    x1: 206.28,
    y1: 199.6,
    x2: 206.56,
    y2: 199.6,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t336-fill-0",
    offset: "0%",
    stopColor: "#475269"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t336-fill-1",
    offset: "100%",
    stopColor: "#363e4f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t337-fill",
    x1: 191.78,
    y1: 195.22,
    x2: 206.55,
    y2: 199.75,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t337-fill-0",
    offset: "0%",
    stopColor: "#5b6a87"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t337-fill-1",
    offset: "100%",
    stopColor: "#2c3340"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t341-fill",
    x1: 222.74,
    y1: 191.14,
    x2: 223.02,
    y2: 191.14,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t341-fill-0",
    offset: "0%",
    stopColor: "#475269"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t341-fill-1",
    offset: "100%",
    stopColor: "#363e4f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t342-fill",
    x1: 208.25,
    y1: 186.76,
    x2: 223.01,
    y2: 191.29,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t342-fill-0",
    offset: "0%",
    stopColor: "#5b6a87"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t342-fill-1",
    offset: "100%",
    stopColor: "#2c3340"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t345-fill",
    x1: 216.58,
    y1: 194.95,
    x2: 222.03,
    y2: 194.95,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t345-fill-0",
    offset: "0%",
    stopColor: "#5b6a87"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t345-fill-1",
    offset: "100%",
    stopColor: "#2c3340"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t347-fill",
    x1: 208.17,
    y1: 199.38,
    x2: 213.82,
    y2: 199.38,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t347-fill-0",
    offset: "0%",
    stopColor: "#5b6a87"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t347-fill-1",
    offset: "100%",
    stopColor: "#2c3340"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t349-fill",
    x1: 221.09,
    y1: 190.62,
    x2: 206.15,
    y2: 200.4,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t349-fill-0",
    offset: "0%",
    stopColor: "#5b6a87"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t349-fill-1",
    offset: "100%",
    stopColor: "#2c3340"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t350-fill",
    x1: 218.24,
    y1: 191.91,
    x2: 209.84,
    y2: 203.53,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t350-fill-0",
    offset: "0%",
    stopColor: "#475269"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t350-fill-1",
    offset: "100%",
    stopColor: "#363e4f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t352-fill",
    x1: 181.48,
    y1: 204.68,
    x2: 196.85,
    y2: 206.01,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t352-fill-0",
    offset: "0%",
    stopColor: "#f7f7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t352-fill-1",
    offset: "100%",
    stopColor: "#bebee0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t354-fill",
    x1: 182.53,
    y1: 193.66,
    x2: 197.9,
    y2: 194.99,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t354-fill-0",
    offset: "0%",
    stopColor: "#f7f7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t354-fill-1",
    offset: "100%",
    stopColor: "#bebee0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t355-fill",
    x1: 198.33,
    y1: 188.25,
    x2: 179.05,
    y2: 188.25,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t355-fill-0",
    offset: "0%",
    stopColor: "#475269"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t355-fill-1",
    offset: "100%",
    stopColor: "#363e4f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t356-fill",
    x1: 187.08,
    y1: 185.19,
    x2: 193.37,
    y2: 190.65,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t356-fill-0",
    offset: "0%",
    stopColor: "#475269"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t356-fill-1",
    offset: "100%",
    stopColor: "#363e4f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t358-fill",
    x1: 184.12,
    y1: 185.02,
    x2: 188.91,
    y2: 186.67,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t358-fill-0",
    offset: "0%",
    stopColor: "#475269"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t358-fill-1",
    offset: "100%",
    stopColor: "#363e4f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t359-fill",
    x1: 182.21,
    y1: 185.22,
    x2: 191.63,
    y2: 189.44,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t359-fill-0",
    offset: "0%",
    stopColor: "#475269"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t359-fill-1",
    offset: "100%",
    stopColor: "#363e4f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t361-fill",
    x1: 198.33,
    y1: 192.32,
    x2: 179.05,
    y2: 192.32,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t361-fill-0",
    offset: "0%",
    stopColor: "#475269"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t361-fill-1",
    offset: "100%",
    stopColor: "#363e4f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t366-fill",
    x1: 125.26,
    y1: 347.32,
    x2: 93.62,
    y2: 293.55,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t366-fill-0",
    offset: "0%",
    stopColor: "#f7f7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t366-fill-1",
    offset: "100%",
    stopColor: "#bebee0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t367-fill",
    x1: 94.17,
    y1: 360,
    x2: 57.56,
    y2: 276.39,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t367-fill-0",
    offset: "0%",
    stopColor: "#f7f7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t367-fill-1",
    offset: "100%",
    stopColor: "#bebee0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t375-fill",
    x1: 99.496488,
    y1: 278.07492,
    x2: 101.276879,
    y2: 221.965732,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t375-fill-0",
    offset: "0%",
    stopColor: "#346d4d"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t375-fill-1",
    offset: "100%",
    stopColor: "#8ac45e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t391-fill",
    x1: 113.033306,
    y1: 290.894807,
    x2: 146.626859,
    y2: 251.349161,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t391-fill-0",
    offset: "0%",
    stopColor: "#346d4d"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t391-fill-1",
    offset: "100%",
    stopColor: "#8ac45e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t405-fill",
    x1: 78.847594,
    y1: 283.433402,
    x2: 41.873729,
    y2: 247.267411,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t405-fill-0",
    offset: "0%",
    stopColor: "#346d4d"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t405-fill-1",
    offset: "100%",
    stopColor: "#8ac45e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t419-fill",
    x1: 208.11,
    y1: 20.12,
    x2: 204.16,
    y2: 42.94,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t419-fill-0",
    offset: "0%",
    stopColor: "#96df78"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t419-fill-1",
    offset: "100%",
    stopColor: "#76cb74"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t423-fill",
    x1: 386.64,
    y1: 210.07,
    x2: 382.68,
    y2: 232.89,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t423-fill-0",
    offset: "0%",
    stopColor: "#ffa408"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t423-fill-1",
    offset: "100%",
    stopColor: "#ffdb0d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eSvLbpigY9t424-fill",
    x1: 75.06,
    y1: 235.82,
    x2: 68.17,
    y2: 223.37,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t424-fill-0",
    offset: "0%",
    stopColor: "#0080ff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eSvLbpigY9t424-fill-1",
    offset: "100%",
    stopColor: "#14dcff"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    },
    transform: "matrix(1.191071 0 0 1.164524 16.137188 19.530206)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "eSvLbpigY9t4_to",
    style: {
      offsetPath: "path('M242.099998,68L242.099998,60Q242.099998,60,242.099998,68')",
      offsetRotate: "0deg"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-242.099998,-69.81704)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176.89,64.11c-1.3.68-2.18,2.4-1.96,3.85l10.57,70.02c.22,1.44,1.45,2.06,2.75,1.38L307.3,77.41c1.3-.68,2.18-2.39,1.97-3.84L298.69,3.56c-.22-1.44-1.45-2.07-2.76-1.39L291.1,4.68l-1.3-3.49c-.43-1.16-1.83-1.53-3.14-.85L252.11,18.32c-1.31.68-2.4,2.34-2.44,3.75l-.13,4.24-72.66,37.81Z",
    fill: "#242b3d"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eSvLbpigY9t6",
    transform: "matrix(.999624 0.027422-.027422 0.999624 2.49544-5.797502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221.39,89.12c-1.02,3.87-3.59,7.43-6.97,9.15-3.3,1.67-6.53,1.14-8.64-1.02l-4.44,5.54c3.42,3.66,8.75,4.58,14.2,1.82c5.58-2.83,9.82-8.76,11.41-15.16l-5.56-.34Z",
    fill: "#3e4e75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.31,71.77c-6.27,3.38-10.74,10.68-11.55,18.04l5.73-.86c.55-4.4,3.22-8.74,6.94-10.83l-1.12-6.35Z",
    fill: "#5d99fa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.67,90.79c-.11,1.6-.04,3.2.23,4.74.48,2.7,1.5,4.93,2.92,6.66l4.44-5.55c-.82-1.04-1.42-2.38-1.7-3.98-.16-.89-.2-1.81-.15-2.73l-5.73.86Z",
    fill: "#b875d0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.11,71.36l1.12,6.35c4.86-2.21,9.5.29,10.46,5.77.26,1.51.22,3.09-.07,4.65l5.54.34c.53-2.62.64-5.29.19-7.85-1.58-8.97-9.25-13.04-17.24-9.25Z",
    fill: "#f56eab"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "eSvLbpigY9t11",
    opacity: 0
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "237.75,58.74 237.53,58.88 237.59,59.1 247.57,62.66 251.24,62.88 251.58,62.9 257.17,63.23 265.69,56.15 274.09,59.81 274.35,59.92 275.71,60.51 278.23,60.15 278.67,60.08 285.06,59.11 285.18,59.02 293.1,47.88 293.11,47.62 292.9,47.68 285.04,58.76 278.38,59.77 277.93,59.84 275.85,60.15 274.48,59.55 274.22,59.44 265.79,55.77 265.64,55.8 257.2,62.86 251.85,62.55 251.51,62.52 247.71,62.3 237.75,58.74",
    fill: "#5d99fa"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.78,74.47 251.23,80.24 250.79,80.96 258.83,74.81 268.47,76.39 268.67,76.24 271.17,69.07 270.89,69.02 268.46,76.01 258.89,74.44 258.78,74.47",
    fill: "#f56eab"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "256.2,56.4 251.51,62.52 251.85,62.55 256.35,56.67 265.49,54.84 275.03,55.36 275.2,55.25 282.73,41.83 291.99,40.91 292.17,40.71 292.04,40.54 282.7,41.47 282.55,41.58 275.03,54.99 265.57,54.46 256.31,56.31 256.2,56.4",
    fill: "#b875d0"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.26,63.91 278.67,60.08 278.23,60.15 282.01,64.19 282.26,63.91",
    fill: "#f56eab"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.16,56.73 274.22,59.44 274.48,59.55 275.34,57.07 277.93,59.83 278.38,59.77 275.41,56.61 275.28,56.58 275.16,56.73",
    fill: "#f56eab"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "274.09,59.81 271.02,68.66 271.29,68.71 274.35,59.92 274.09,59.81",
    fill: "#f56eab"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.46,68.38 282.46,64.12 282.21,64.41 286.32,68.79 286.53,68.75 294.61,58.66 294.63,58.4 294.41,58.43 286.46,68.38",
    fill: "#f56eab"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.21,62.05 238,62.17 238.04,62.41 248.2,67.15 248.37,67.09 251.58,62.9 251.24,62.88 248.27,66.77 238.21,62.05",
    fill: "#b875d0"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.06,68.71 257.92,68.81 250.6,80.72 250.23,81.33 250.11,81.37 241.24,84.33 241.09,84.56 241.24,84.68 250.3,81.67 250.42,81.57 250.79,80.96 251.23,80.24 258.08,69.07 267.37,68.38 270.89,69.02 271.17,69.07 277.09,70.15 277.24,70.09 282.21,64.41 282.46,64.12 285.4,60.77 293.88,53.8 293.96,53.54 293.76,53.52 285.26,60.49 282.26,63.91 282.01,64.19 277.13,69.78 271.29,68.71 271.02,68.66 267.48,68.01 258.06,68.71",
    fill: "#3e4e75"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.92,81.9 240.76,82.09 240.87,82.27 250.11,81.37 250.23,81.33 250.6,80.72 250.24,81 240.92,81.9",
    fill: "#f56eab"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "291.21,28.45 296.8,68.52 242.83,95.87 242.88,96.21 297.16,68.71 291.51,28.29 291.21,28.45",
    fill: "#3e4e75"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M254.1,22.64c-.13.07-.27.08-.39.02l-.43-.21-.3.59c-.09.17-.21.29-.34.36s-.27.08-.39.02c-.23-.12-.29-.49-.12-.81l.31-.6-.43-.21c-.23-.12-.29-.49-.12-.81.09-.17.21-.29.34-.36s.27-.08.39-.02l.42.21.31-.59c.08-.17.2-.29.34-.36.13-.07.27-.08.39-.02.23.12.29.48.12.81l-.31.59.43.22c.23.12.29.48.12.81-.09.17-.21.29-.34.36Z",
    fill: "#3e4e75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.63,60.76l97.54-50.75c1.3-.68,2.54-.06,2.75,1.38l.58,3.81c.22,1.44-.66,3.17-1.96,3.85L196,69.8c-1.3.68-2.54.05-2.75-1.39l-.58-3.81c-.22-1.44.66-3.16,1.96-3.84Z",
    fill: "#3e4e75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.75,69.31l6.76-3.52c.34-.18.67-.01.73.37s-.18.84-.52,1.01l-6.76,3.52c-.35.18-.67.02-.73-.37-.06-.38.17-.84.52-1.02Z",
    fill: "#3e4e75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.53,74.51l6.76-3.52c.34-.18.67,0,.73.37.06.38-.18.84-.52,1.01l-6.76,3.52c-.35.18-.67.02-.73-.37-.06-.38.17-.83.52-1.01Z",
    fill: "#3e4e75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.14,71.91l6.76-3.52c.34-.18.67-.01.73.37s-.18.84-.52,1.02l-6.76,3.52c-.35.18-.67.02-.73-.37-.06-.38.17-.83.52-1.01Z",
    fill: "#3e4e75"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M249.54,26.31l.13-4.24c.04-1.41,1.13-3.07,2.44-3.75L286.67,0.34c1.3-.68,2.7-.32,3.14.85l1.3,3.49l4.83-2.51c1.3-.68,2.54-.05,2.76,1.39l10.57,70.02c.22,1.44-.66,3.16-1.97,3.84l-32.49,16.9L202.6,50.73L249.54,26.3Z",
    opacity: 0.2,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "eSvLbpigY9t30_to",
    transform: "translate(110.448635,130)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-109.448635,-138.156242)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.24,132.45c-1.3.68-2.18,2.4-1.96,3.85l10.57,70.02c.22,1.45,1.45,2.06,2.75,1.38l119.05-61.95c1.3-.68,2.18-2.4,1.97-3.84L166.05,71.89c-.22-1.44-1.45-2.07-2.76-1.39l-4.83,2.52-1.3-3.5c-.43-1.16-1.83-1.52-3.14-.85L119.47,86.65c-1.31.68-2.4,2.34-2.44,3.75l-.13,4.24-72.66,37.81Z",
    transform: "translate(0-.263135)",
    fill: "#242b3d"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "eSvLbpigY9t33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.88,100.82c-2.6,1.4-4.73,3.93-5.99,6.8l1.78.6c.96-2.18,2.58-4.09,4.55-5.16l-.34-2.24Z",
    fill: "#3e4e75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.14,100.68l.34,2.24c3.63-1.81,7.04-.06,7.65,3.96.61,4.07-1.87,8.93-5.55,10.84s-7.15.16-7.77-3.91c-.26-1.72.03-3.58.74-5.3l-1.78-.59c-.93,2.24-1.32,4.68-.98,6.94.8,5.3,5.33,7.58,10.12,5.09s8.03-8.81,7.23-14.12c-.79-5.25-5.26-7.54-10-5.15Z",
    fill: "#f56eab"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.44,138.35c-3.35,1.8-5.92,5.48-6.84,9.34h1.97c.72-2.94,2.67-5.72,5.21-7.1l-.34-2.23Z",
    fill: "#3e4e75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.71,138.22l.34,2.23c3.62-1.8,7.03-.05,7.64,3.97.62,4.07-1.86,8.92-5.54,10.83s-7.16.16-7.77-3.91c-.16-1.08-.11-2.22.13-3.34h-1.96c-.32,1.47-.4,2.97-.18,4.39.8,5.3,5.33,7.58,10.13,5.09c4.79-2.49,8.02-8.81,7.22-14.11-.79-5.26-5.26-7.54-9.99-5.16Z",
    transform: "translate(0-.263135)",
    fill: "#b875d0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eSvLbpigY9t38",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.12,127.07l.34,2.23c3.63-1.8,7.04-.06,7.65,3.97.61,4.07-1.87,8.93-5.55,10.84-1.58.82-3.13.96-4.43.54l-1.03,2.39c1.7.57,3.73.38,5.79-.7c4.79-2.49,8.03-8.81,7.23-14.12-.79-5.26-5.26-7.54-10-5.15Z",
    fill: "#7dd075"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.87,127.2c-4.72,2.54-7.89,8.79-7.09,14.05.44,2.91,2,4.9,4.11,5.71l1.03-2.39c-1.61-.62-2.78-2.15-3.12-4.37-.61-4.02,1.81-8.8,5.41-10.76l-.34-2.24Z",
    fill: "#3e4e75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.72,111.83l.34,2.24c3.62-1.81,7.03-.05,7.64,3.97.62,4.07-1.86,8.92-5.54,10.83-2.65,1.38-5.2.86-6.64-1.06l-1.69,1.88c1.88,2.52,5.21,3.2,8.66,1.41c4.79-2.49,8.02-8.81,7.22-14.11-.79-5.26-5.26-7.54-9.99-5.16Z",
    fill: "#5d99fa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.46,111.96c-4.71,2.54-7.89,8.79-7.09,14.05.21,1.37.67,2.54,1.32,3.48l1.69-1.88c-.48-.72-.83-1.61-.99-2.64-.61-4.02,1.81-8.81,5.41-10.76l-.34-2.24Z",
    fill: "#3e4e75"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "61.21,146.43 61.44,147.84 52.6,152.44 52.37,151.03 61.21,146.43",
    fill: "#f56eab"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.68,161.66 63.91,163.07 55.07,167.67 54.85,166.26 63.68,161.66",
    fill: "#f56eab"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.54,170.44 77.77,171.85 68.93,176.44 68.7,175.04 77.54,170.44",
    fill: "#f56eab"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.25,126.12 100.48,127.52 91.64,132.12 91.41,130.72 100.25,126.12",
    fill: "#6ef5c8"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.39,122.4 107.62,123.81 102.35,126.55 102.12,125.14 107.39,122.4",
    fill: "#5e93ff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.15,139.78 95.38,141.19 65.71,156.63 65.48,155.22 95.15,139.78",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.25,136.83 90.47,138.24 81.64,142.84 81.41,141.43 90.25,136.83",
    fill: "#6ef5c8"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.56,142.39 79.79,143.8 64.88,151.55 64.66,150.15 79.56,142.39",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "89.57,131.68 89.8,133.08 64.06,146.47 63.83,145.07 89.57,131.68",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.84,134.22 106.06,135.63 97.23,140.23 97,138.82 105.84,134.22",
    fill: "#6ef5c8"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.38,133.12 97.61,134.52 92.35,137.27 92.12,135.86 97.38,133.12",
    fill: "#5e93ff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "112.97,130.51 113.2,131.92 107.94,134.66 107.71,133.25 112.97,130.51",
    fill: "#5e93ff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.38,151.5 104.61,152.91 95.77,157.5 95.54,156.1 104.38,151.5",
    fill: "#6ef5c8"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.96,149.85 97.19,151.26 88.35,155.86 88.12,154.45 96.96,149.85",
    fill: "#6ef5c8"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "89.86,148.04 90.09,149.44 81.25,154.05 81.02,152.64 89.86,148.04",
    fill: "#6ef5c8"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97,144.33 97.23,145.73 91.96,148.47 91.73,147.07 97,144.33",
    fill: "#5e93ff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.17,153.6 79.4,155.01 66.54,161.7 66.31,160.3 79.17,153.6",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.1,146.14 104.33,147.55 99.06,150.29 98.83,148.88 104.1,146.14",
    fill: "#5e93ff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.28,155.41 86.51,156.82 67.36,166.78 67.13,165.38 86.28,155.41",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.7,157.06 93.92,158.46 68.19,171.85 67.96,170.45 93.7,157.06",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "89.39,164.27 89.62,165.68 80.78,170.28 80.55,168.87 89.39,164.27",
    fill: "#6ef5c8"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.52,147.78 111.75,149.19 106.48,151.93 106.25,150.52 111.52,147.78",
    fill: "#5e93ff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "74.63,179.1 74.86,180.51 70,183.03 69.78,181.63 74.63,179.1",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.43,184.02 75.66,185.42 70.8,187.94 70.57,186.54 75.43,184.02",
    fill: "#fff"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M121.45,90.98c-.13.07-.27.08-.39.02l-.43-.21-.3.59c-.09.17-.21.29-.34.36s-.27.08-.39.02c-.23-.12-.29-.48-.12-.81l.31-.6-.43-.21c-.23-.12-.29-.49-.12-.81.09-.17.21-.29.34-.36s.27-.08.39-.02l.42.21.31-.59c.08-.16.2-.29.34-.36.13-.07.27-.08.39-.02.23.12.29.48.12.81l-.31.59.43.21c.23.12.29.49.12.81-.09.17-.21.29-.34.36Z",
    fill: "#3e4e75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.99,129.1l97.54-50.75c1.3-.68,2.54-.06,2.75,1.38l.58,3.81c.22,1.44-.66,3.17-1.96,3.85L63.36,138.14c-1.3.68-2.54.05-2.75-1.39l-.58-3.81c-.22-1.44.66-3.16,1.96-3.84Z",
    fill: "#3e4e75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1,137.65l6.76-3.52c.34-.18.67,0,.73.37.06.38-.18.84-.52,1.02l-6.76,3.52c-.35.18-.67.02-.73-.37-.06-.38.17-.83.52-1.02Z",
    fill: "#3e4e75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.89,142.84l6.76-3.52c.34-.18.67-.01.73.37s-.18.84-.52,1.01l-6.76,3.52c-.35.18-.67.02-.73-.37-.06-.38.17-.84.52-1.02Z",
    fill: "#3e4e75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.49,140.25l6.76-3.52c.34-.18.67,0,.73.37.06.38-.18.84-.52,1.02l-6.76,3.52c-.35.18-.67.02-.73-.37-.06-.38.17-.83.52-1.01Z",
    fill: "#3e4e75"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M116.89,94.65l.13-4.24c.04-1.41,1.13-3.07,2.44-3.75l34.55-17.98c1.3-.68,2.7-.31,3.14.85l1.3,3.5l4.83-2.52c1.3-.68,2.54-.05,2.76,1.39l10.57,70.02c.22,1.44-.66,3.16-1.97,3.84l-32.49,16.9-72.21-43.59l46.94-24.43Z",
    opacity: 0.2,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", null, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "294.09,180.73 319.46,194.02 311.57,240.58 294.06,231.41 276.44,240.58 268.55,194.02 294.09,180.73",
    fill: "#8c5e4c"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.88,213.78 293.92,254.21 320.13,240.58 331.86,194.02 293.88,213.78",
    fill: "url(#eSvLbpigY9t78-fill)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "256.15,194.02 267.88,240.58 293.92,254.21 293.88,213.78 256.15,194.02",
    fill: "url(#eSvLbpigY9t79-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "321.5,235.14 320.13,240.58 293.92,254.21 293.9,254.2 293.9,249.5 321.5,235.14",
    fill: "#eda468"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.52,235.15 293.9,249.5 293.9,254.2 267.88,240.58 266.52,235.15",
    fill: "#b57962"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "293.88,214.66 256.41,195.03 256.15,194.02 293.88,213.78 331.86,194.02 331.6,195.03 293.88,214.66",
    opacity: 0.3,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.13,174.26l-37.98,19.76l37.73,19.76l37.98-19.76-37.73-19.76Zm-.21,33.05l-25.37-13.29l25.54-13.29l25.37,13.29-25.54,13.29",
    fill: "#c8c8e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.79,206.02c-.35,0-.72,0-1.12-.02-2.98-.32-4.52-1.47-5.99-2.73l17.78-9.25-15.21-7.96c2.5-.54,4.63.26,7.78-2.09.1-.06.17-.13.26-.19l19.56,10.25-23.07,12.01Z",
    fill: "#acacd1"
  }))), /*#__PURE__*/React.createElement("g", null, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M318.38,130.89c-.99-5.97,1.39-6.01-.69-12.05-2.41-5.97-5.63-8.29-8.4-13.99-4.55,4.67-8.41,5.99-12.71,11.03-4.02,5.18-1.76,5.87-4.72,11.29-2.66,5.52-5.51,4.95-7.88,10.77-2.06,5.9,1.34,6.32.32,12.22-.71,5.94-4.64,5.78-4.99,11.96-.02,6.19,4.39,6.08,5.38,12.05c1.3,5.94-3.53,6.41-1.76,12.51c2.1,6.04,7.3,5.21,10.36,10.82c4.81-4.51,9.48-2.29,13.52-7.47c3.74-5.32-.71-7.09,2.54-12.4c2.95-5.41,7.12-4.11,9.18-10.01c1.76-5.97-2.04-6.9-.72-12.76c1.02-5.9,4.4-5.36,4.43-11.55-.29-6.19-3.2-6.43-3.87-12.42Z",
    fill: "url(#eSvLbpigY9t87-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M279.32,162.11c.26-4.74,2.64-5.76,4.05-8.66.2.63.48,1.32.93,2.12c2.4,4.79,5.64,3.68,7.79,8.75c1.9,5.16-1.81,6.16-.83,11.39.72,5.29,4.9,4.48,5.27,10.01.07,4.79-3.32,5.9-4.81,9.58-3.04-3.32-7.02-3.53-8.79-8.63-1.77-6.09,3.06-6.56,1.76-12.51-.99-5.97-5.4-5.86-5.38-12.05Z",
    fill: "#a9d1b5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M319.09,134.09c-2.47,2.92-1.42,4.06-4.31,7.88-3.07,4.51-5.48,3.7-8.33,8.5-2.6,4.91.31,5.64-1.39,10.67-1.43,5.09-4.83,4.52-5.97,9.85-.86,5.38,2.99,5.78,3.03,11.08.32,5.32-3.95,5.19-3.24,10.69.11.58.26,1.08.44,1.55c2.64-.77,5.17-1.3,7.49-4.28c3.74-5.32-.71-7.09,2.54-12.4c2.95-5.41,7.12-4.11,9.18-10.01c1.76-5.97-2.04-6.9-.72-12.76c1.02-5.9,4.4-5.36,4.43-11.55-.23-4.84-2.05-6.05-3.16-9.21Z",
    fill: "#a9d1b5"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eSvLbpigY9t100)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 309.81,
    y1: 101.81,
    x2: 292.7,
    y2: 200.95,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "323.23,177.49 294.29,191.75 271.52,170.24",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "325.87,162.15 296.93,176.41 274.17,154.9",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    points: "328.52,146.81 299.58,161.07 276.82,139.56",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    points: "331.17,131.47 302.23,145.72 279.47,124.22",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    points: "333.82,116.13 304.88,130.38 282.12,108.88",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _polyline6 || (_polyline6 = /*#__PURE__*/React.createElement("polyline", {
    points: "336.47,100.79 307.53,115.04 284.77,93.53",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "eSvLbpigY9t100"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.3,197.49c-3.06-5.61-8.26-4.78-10.36-10.82-1.77-6.09,3.06-6.56,1.76-12.51-.99-5.97-5.4-5.86-5.38-12.05.34-6.17,4.27-6.01,4.99-11.96c1.02-5.9-2.39-6.32-.32-12.22c2.36-5.82,5.22-5.25,7.88-10.77c2.96-5.42.7-6.11,4.72-11.29c4.31-5.04,8.16-6.35,12.71-11.03c2.76,5.7,5.99,8.01,8.4,13.99c2.08,6.03-.3,6.07.69,12.05.68,5.99,3.58,6.23,3.87,12.42-.02,6.19-3.41,5.65-4.43,11.55-1.33,5.86,2.48,6.79.72,12.76-2.07,5.9-6.23,4.59-9.18,10.01-3.25,5.3,1.21,7.08-2.54,12.4-4.04,5.18-8.71,2.97-13.52,7.47Z",
    fill: "none"
  }))))), /*#__PURE__*/React.createElement("g", null, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M353.3,166.29c2.95-4.59,4.61-3.45,6.84-8.62c1.97-5.29,1.16-8.47,2.72-13.76-5.97.97-9.42-.03-15.43,1.31-5.91,1.58-4.77,3.17-10.1,5.43-5.18,2.48-6.8.69-11.96,3.52-5,3.04-2.92,5-7.2,8.56-4.1,3.73-6.7,1.68-10.69,5.76-3.77,4.24-.68,6.35-3.62,10.93-2.71,4.73-6.32,2.67-8.81,7.73-2.23,5.19,1.85,7.18.55,12.55c6.04-.72,7.91,3.1,13.83,1.54c5.81-1.81,3.82-5.22,9.27-7.27c5.32-2.26,7.39.69,12.39-2.35c4.84-3.24,2.79-5.75,7.25-9.12c4.29-3.55,6.28-1.51,10.06-5.75c3.56-4.4,1.71-6,4.88-10.45Z",
    fill: "url(#eSvLbpigY9t103-fill)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eSvLbpigY9t114)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }, _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 365.08,
    y1: 142.08,
    x2: 293.1,
    y2: 201.78,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _polyline7 || (_polyline7 = /*#__PURE__*/React.createElement("polyline", {
    points: "328.33,200.72 299.78,196.24 297.2,170.23",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _polyline8 || (_polyline8 = /*#__PURE__*/React.createElement("polyline", {
    points: "339.47,191.48 310.92,187 308.33,160.99",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _polyline9 || (_polyline9 = /*#__PURE__*/React.createElement("polyline", {
    points: "350.61,182.24 322.06,177.77 319.47,151.75",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _polyline10 || (_polyline10 = /*#__PURE__*/React.createElement("polyline", {
    points: "361.75,173 333.2,168.52 330.61,142.51",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _polyline11 || (_polyline11 = /*#__PURE__*/React.createElement("polyline", {
    points: "372.88,163.76 344.33,159.29 341.75,133.27",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _polyline12 || (_polyline12 = /*#__PURE__*/React.createElement("polyline", {
    points: "384.02,154.52 355.47,150.05 352.89,124.04",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "eSvLbpigY9t114"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.61,199.7c1.3-5.37-2.78-7.36-.55-12.55c2.48-5.06,6.09-3,8.81-7.73c2.94-4.59-.15-6.69,3.62-10.93c3.98-4.08,6.59-2.03,10.69-5.76c4.29-3.55,2.2-5.52,7.2-8.56c5.16-2.83,6.77-1.04,11.96-3.52c5.32-2.26,4.19-3.85,10.1-5.43c6.02-1.33,9.47-.34,15.43-1.31-1.56,5.28-.75,8.46-2.72,13.76-2.24,5.17-3.9,4.03-6.84,8.62-3.17,4.45-1.32,6.05-4.88,10.45-3.78,4.24-5.77,2.2-10.06,5.75-4.47,3.37-2.42,5.88-7.25,9.12-5,3.04-7.07.09-12.39,2.35-5.45,2.04-3.47,5.46-9.27,7.27-5.93,1.57-7.79-2.26-13.83-1.54Z",
    fill: "none"
  }))))), /*#__PURE__*/React.createElement("g", null, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M258.24,143.1c-4.88-2.97-3.49-4.38-9.06-6.76-5.72-2.15-9.3-1.64-15.03-3.41.65,5.43-.69,8.46.36,13.97c1.33,5.42,3.17,4.51,5.3,9.46c2.38,4.83.28,6.16,3.05,10.99c3.01,4.71,5.33,2.97,8.97,7.08c3.85,3.94,1.39,6.14,5.62,10.01c4.43,3.69,6.98,1.06,11.85,4.03c5.04,2.77,2.51,5.87,7.94,8.46c5.59,2.37,8.08-1.16,13.93.38-.38-5.48,3.99-6.89,2.67-12.33-1.59-5.35-5.51-3.8-7.4-8.85-2.13-4.94,1.28-6.59-1.73-11.3-3.25-4.58-6.17-2.91-9.59-7.16-3.63-4.1-1.23-5.76-5.66-9.45-4.62-3.51-6.52-1.96-11.22-5.12Z",
    fill: "url(#eSvLbpigY9t117-fill)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eSvLbpigY9t128)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }, _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 232.27,
    y1: 130.82,
    x2: 293.3,
    y2: 199.72,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _polyline13 || (_polyline13 = /*#__PURE__*/React.createElement("polyline", {
    points: "294.59,167.97 287.64,193.32 258.66,193.82",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _polyline14 || (_polyline14 = /*#__PURE__*/React.createElement("polyline", {
    points: "285.15,157.31 278.19,182.66 249.22,183.16",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _polyline15 || (_polyline15 = /*#__PURE__*/React.createElement("polyline", {
    points: "275.7,146.64 268.75,172 239.78,172.5",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _polyline16 || (_polyline16 = /*#__PURE__*/React.createElement("polyline", {
    points: "266.26,135.98 259.3,161.34 230.33,161.84",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _polyline17 || (_polyline17 = /*#__PURE__*/React.createElement("polyline", {
    points: "256.82,125.32 249.86,150.68 220.89,151.18",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _polyline18 || (_polyline18 = /*#__PURE__*/React.createElement("polyline", {
    points: "247.37,114.66 240.42,140.01 211.44,140.51",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "eSvLbpigY9t128"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.17,197.31c-5.85-1.54-8.34,1.98-13.93-.38-5.43-2.59-2.89-5.69-7.94-8.46-4.87-2.97-7.42-.33-11.85-4.03-4.23-3.87-1.78-6.07-5.62-10.01-3.63-4.1-5.95-2.37-8.97-7.08-2.77-4.83-.68-6.16-3.05-10.99-2.13-4.95-3.97-4.04-5.3-9.46-1.05-5.51.29-8.54-.36-13.97c5.74,1.78,9.31,1.27,15.03,3.41c5.57,2.37,4.18,3.79,9.06,6.76c4.7,3.16,6.6,1.61,11.22,5.12c4.43,3.69,2.03,5.35,5.66,9.45c3.42,4.25,6.34,2.58,9.59,7.16c3.01,4.71-.4,6.36,1.73,11.3c1.88,5.05,5.8,3.5,7.4,8.85c1.32,5.44-3.05,6.84-2.67,12.33Z",
    fill: "none"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "119.56,320.77 124.26,318.31 124.25,208.25 119.56,210.71 119.56,320.77",
    fill: "#614134"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "187.06,355.89 191.76,353.43 191.76,240.11 187.06,242.57 187.06,355.89",
    fill: "#614134"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "187.06,242.57 191.76,240.11 121.11,203.35 116.42,205.81 187.06,242.57",
    fill: "#9c6854"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "116.42,205.81 116.42,319.13 119.56,320.77 119.56,210.71 183.91,244.19 183.92,354.26 187.06,355.89 187.06,242.57 116.42,205.81",
    fill: "#8c5e4c"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "250.01,252.66 254.7,250.2 254.69,140.14 250,142.59 250.01,252.66",
    fill: "#614134"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "317.51,287.78 322.2,285.32 322.2,172 317.51,174.46 317.51,287.78",
    fill: "#614134"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "317.51,174.46 322.2,172 251.56,135.24 246.86,137.7 317.51,174.46",
    fill: "#9c6854"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "246.86,137.7 246.86,251.02 250.01,252.66 250,142.59 314.35,176.08 314.36,286.14 317.51,287.78 317.51,174.46 246.86,137.7",
    fill: "#8c5e4c"
  }))), /*#__PURE__*/React.createElement("g", null, _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "329.65,171.62 329.65,178.01 190.5,251.4 190.5,245.02 329.65,171.62",
    fill: "#fcbb86"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "329.65,171.62 190.5,245.02 109.45,204.02 248.6,130.63 329.65,171.62",
    fill: "#eda468"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "190.5,245.02 190.5,251.4 109.45,210.41 109.45,204.02 190.5,245.02",
    fill: "#b57962"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      mixBlendMode: "overlay"
    },
    points: "109.45,204.02 109.45,205.02 190.5,246.02 329.65,172.62 329.65,171.62 190.5,245.02 109.45,204.02",
    opacity: 0.4,
    fill: "#fffbf7"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M196.62,139.79l51.06-26.57c.23-.12.46-.15.67-.1.41.09.81.18,1.21.27-.21-.05-.44-.02-.67.1l-51.06,26.57c-.6.31-.95,1.12-.79,1.8l8.31,34.22c.1.42.38.7.72.77l-1.21-.27c-.34-.08-.61-.35-.72-.77l-8.31-34.22c-.16-.68.19-1.49.79-1.8Z",
    fill: "#1c2229"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M197.83,140.06l51.06-26.57c.6-.31,1.22,0,1.39.67l8.31,34.22c.16.68-.19,1.49-.79,1.8l-51.06,26.57c-.6.31-1.22,0-1.39-.67l-8.31-34.22c-.16-.68.19-1.49.79-1.8Z",
    fill: "url(#eSvLbpigY9t149-fill)"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "249.37,115.22 256.93,146.37 205.78,172.99 198.21,141.84 249.37,115.22",
    fill: "#242b3d"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "eSvLbpigY9t151"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "242.79,124.26 242.97,124.87 248.46,122.08 248.28,121.46 242.79,124.26",
    fill: "#7dd075"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.01,139.96 212.19,140.57 215.75,138.76 215.56,138.14 212.01,139.96",
    fill: "#b875d0"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "207.47,142.27 207.66,142.88 211.21,141.07 211.03,140.46 207.47,142.27",
    fill: "#5d99fa"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.26,137.55 238.44,138.16 249,132.78 248.81,132.16 238.26,137.55",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "232.99,140.23 233.17,140.84 237.5,138.64 237.31,138.03 232.99,140.23",
    fill: "#7dd075"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.25,136.88 245.43,137.49 249.76,135.29 249.57,134.68 245.25,136.88",
    fill: "#7dd075"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.38,147.25 248.56,147.87 252.88,145.67 252.7,145.05 248.38,147.25",
    fill: "#5d99fa"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.6,144.66 247.78,145.27 252.1,143.07 251.92,142.46 247.6,144.66",
    fill: "#b875d0"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "246.81,142.07 247,142.68 251.32,140.48 251.13,139.87 246.81,142.07",
    fill: "#7dd075"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "246.03,139.48 246.22,140.09 250.54,137.89 250.36,137.28 246.03,139.48",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.42,148.32 240.6,148.94 244.92,146.73 244.74,146.12 240.42,148.32",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "229.44,150.93 229.62,151.54 246.3,143.04 246.12,142.43 229.44,150.93",
    fill: "#f56eab"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.97,139.58 240.15,140.19 244.47,137.98 244.29,137.37 239.97,139.58",
    fill: "#f56eab"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.63,142.88 222.81,143.49 248.31,130.49 248.12,129.88 222.63,142.88",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.94,140.6 222.13,141.21 247.62,128.21 247.44,127.6 221.94,140.6",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.25,138.32 221.44,138.93 246.93,125.93 246.75,125.32 221.25,138.32",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.42,137.71 216.6,138.32 242.09,125.32 241.91,124.71 216.42,137.71",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M248.9,113.49c.6-.31,1.22,0,1.39.67l8.31,34.22c.16.68-.19,1.49-.79,1.8l-6.62,3.45-42.65-19.14l40.37-21.01Z",
    opacity: 0.2,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M206.65,177.02l29.86,15.64c.59.31,1.57.31,2.17,0l51.06-26.57c.3-.16.45-.36.45-.57c0,.62,0,1.25,0,1.88c0,.21-.15.41-.45.57l-51.06,26.57c-.6.31-1.57.31-2.16,0L206.66,178.9c-.29-.15-.44-.36-.44-.56c0-.62,0-1.25,0-1.87c0,.2.15.41.44.56Z",
    fill: "#b0b2c9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M229.2,189.76l2.45,1.28c.2.1.35.35.35.55s-.16.28-.35.18l-2.45-1.28c-.2-.1-.35-.35-.35-.55s.16-.29.36-.18Z",
    fill: "#7c80a6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M206.65,177.02l29.86,15.64c.59.31,1.57.31,2.17,0l51.06-26.57c.3-.16.45-.36.45-.57c0,.08,0,.17,0,.26-.01.2-.16.39-.45.54l-51.06,26.57c-.6.31-1.57.31-2.16,0l-29.86-15.64c-.29-.15-.44-.36-.44-.56v-.2c.01.2.16.38.44.53Z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M206.65,175.89l51.06-26.57c.6-.31,1.57-.31,2.17,0l29.85,15.64c.59.31.59.82,0,1.13l-51.06,26.57c-.6.31-1.57.31-2.17,0l-29.86-15.64c-.59-.31-.59-.82,0-1.13Z",
    fill: "url(#eSvLbpigY9t174-fill)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M228.46,175.19l-1.46.76c-.33.17-.86.17-1.19,0l-1.51-.79c-.32-.17-.32-.45,0-.62l1.46-.76c.33-.17.86-.17,1.19,0l1.51.79c.33.17.32.45,0,.62Z",
    fill: "url(#eSvLbpigY9t176-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.41,166.55l-1.52.79c-.33.17-.86.17-1.19,0l-.22-.12c-.33-.17-.32-.45,0-.62l1.52-.79c.33-.17.86-.17,1.19,0l.22.12c.33.17.32.45,0,.62Z",
    fill: "url(#eSvLbpigY9t177-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.16,168.24l-1.35.7c-.33.17-.86.17-1.19,0l-.22-.12c-.33-.17-.33-.45,0-.62l1.35-.7c.33-.17.86-.17,1.19,0l.22.12c.32.17.32.45,0,.62Z",
    fill: "url(#eSvLbpigY9t178-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.1,169.83l-1.41.73c-.33.17-.86.17-1.19,0l-.22-.12c-.33-.17-.33-.45,0-.62l1.41-.73c.33-.17.86-.17,1.19,0l.22.12c.33.17.32.45,0,.62Z",
    fill: "url(#eSvLbpigY9t179-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.37,169.23l1.35-.7c.33-.17.86-.17,1.19,0l1.35.71c.32.17.32.45,0,.62l-1.35.7c-.33.17-.86.17-1.19,0l-1.35-.71c-.33-.17-.32-.45,0-.62Z",
    fill: "url(#eSvLbpigY9t180-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.24,170.85l1.41-.73c.33-.17.86-.17,1.19,0l1.35.71c.33.17.32.45,0,.62l-1.41.73c-.33.17-.86.17-1.19,0l-1.35-.71c-.33-.17-.32-.45,0-.62Z",
    fill: "url(#eSvLbpigY9t181-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.97,171.46l-1.46.76c-.33.17-.86.17-1.19,0l-.22-.12c-.33-.17-.33-.45,0-.62l1.46-.76c.33-.17.86-.17,1.19,0l.22.12c.33.17.33.45,0,.62Z",
    fill: "url(#eSvLbpigY9t182-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.65,171.97l-1.35.7c-.33.17-.86.17-1.19,0l-1.51-.79c-.32-.17-.32-.45,0-.62l1.34-.7c.33-.17.86-.17,1.19,0l1.51.79c.33.17.32.45,0,.62Z",
    fill: "url(#eSvLbpigY9t183-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.85,172.44l-1.52.79c-.33.17-.86.17-1.19,0l-1.34-.7c-.33-.17-.32-.45,0-.62l1.52-.79c.33-.17.86-.17,1.19,0l1.34.7c.33.17.32.45,0,.62Z",
    fill: "url(#eSvLbpigY9t184-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.41,173.84l-1.35-.71c-.33-.17-.32-.45,0-.62l1.46-.76c.33-.17.86-.17,1.19,0l1.35.71c.32.17.32.45,0,.62l-1.46.76c-.33.17-.86.17-1.19,0Z",
    fill: "url(#eSvLbpigY9t185-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.79,173.12l-1.52.79c-.33.17-.86.17-1.19,0l-.22-.12c-.33-.17-.33-.45,0-.62l1.52-.79c.33-.17.86-.17,1.19,0l.22.12c.33.17.32.45,0,.62Z",
    fill: "url(#eSvLbpigY9t186-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.48,173.5c-.33-.17-.32-.45,0-.62l1.4-.73c.33-.17.86-.17,1.19,0l1.51.79c.33.17.33.45,0,.62l-1.4.73c-.33.17-.87.17-1.19,0l-1.51-.79Z",
    fill: "url(#eSvLbpigY9t187-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.61,174.13l-1.35.7c-.33.17-.86.17-1.19,0l-1.34-.7c-.33-.17-.32-.45,0-.62l1.35-.7c.33-.17.86-.17,1.19,0l1.34.7c.33.17.32.45,0,.62Z",
    fill: "url(#eSvLbpigY9t188-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.55,174.8l-1.35.7c-.33.17-.86.17-1.19,0l-.22-.12c-.33-.17-.33-.45,0-.62l1.35-.7c.33-.17.86-.17,1.19,0l.22.12c.33.17.32.45,0,.62Z",
    fill: "url(#eSvLbpigY9t189-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.64,174.75l-1.52.79c-.33.17-.86.17-1.19,0l-1.4-.73c-.32-.17-.32-.45,0-.62l1.52-.79c.33-.17.86-.17,1.19,0l1.4.73c.33.17.33.45,0,.62Z",
    fill: "url(#eSvLbpigY9t190-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.54,175.72l-1.4.73c-.33.17-.86.17-1.19,0l-1.34-.7c-.33-.17-.33-.45,0-.62l1.4-.73c.33-.17.86-.17,1.19,0l1.34.7c.33.17.33.45,0,.62Z",
    fill: "url(#eSvLbpigY9t191-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.1,177.12l-1.35-.7c-.33-.17-.32-.45,0-.62l4.59-2.39c.33-.17.86-.17,1.19,0l1.35.71c.33.17.32.45,0,.62l-4.59,2.39c-.33.17-.86.17-1.19,0Z",
    fill: "url(#eSvLbpigY9t192-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.4,176.44l-1.35.7c-.33.17-.86.17-1.19,0l-1.4-.73c-.32-.17-.32-.45,0-.62l1.35-.7c.33-.17.86-.17,1.19,0l1.4.73c.33.17.32.45,0,.62Z",
    fill: "url(#eSvLbpigY9t193-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.41,176.53l1.67-.87c.33-.17.86-.17,1.19,0l.22.12c.32.17.32.45,0,.62l-1.67.87c-.33.17-.86.17-1.19,0l-.22-.12c-.33-.17-.33-.45,0-.62Z",
    fill: "url(#eSvLbpigY9t194-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.32,178.8l-1.51-.79c-.33-.17-.32-.45,0-.62l3.77-1.96c.33-.17.86-.17,1.19,0l1.51.79c.33.17.32.45,0,.62l-3.77,1.96c-.33.17-.86.17-1.19,0Z",
    fill: "url(#eSvLbpigY9t195-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.37,177.55l1.67-.87c.33-.17.86-.17,1.19,0l1.35.71c.32.17.32.45,0,.62l-1.67.87c-.33.17-.86.17-1.19,0l-1.35-.71c-.33-.17-.32-.45,0-.62Z",
    fill: "url(#eSvLbpigY9t196-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.34,178.03l-4.46,2.32c-.33.17-.86.17-1.19,0l-1.4-.73c-.33-.17-.32-.45,0-.62l4.46-2.32c.33-.17.86-.17,1.19,0l1.4.73c.33.17.33.45,0,.62Z",
    fill: "url(#eSvLbpigY9t197-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.37,180.4l-1.34-.7c-.33-.17-.33-.45,0-.62l5.86-3.05c.33-.17.86-.17,1.19,0l1.34.7c.33.17.33.45,0,.62l-5.86,3.05c-.33.17-.86.17-1.19,0Z",
    fill: "url(#eSvLbpigY9t198-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.42,179.15l1.67-.87c.33-.17.86-.17,1.19,0l1.51.79c.33.17.33.45,0,.62l-1.67.87c-.33.17-.86.17-1.19,0l-1.51-.79c-.33-.17-.33-.45,0-.62Z",
    fill: "url(#eSvLbpigY9t199-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.4,180.63l1.53-.8c.33-.17.86-.17,1.19,0l1.39.73c.32.17.32.45,0,.62l-1.53.8c-.33.17-.86.17-1.19,0l-1.39-.73c-.33-.17-.32-.45,0-.62Z",
    fill: "url(#eSvLbpigY9t200-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.16,181.25l-1.5.78c-.33.17-.86.17-1.19,0l-1.4-.73c-.32-.17-.32-.45,0-.62l1.5-.78c.33-.17.87-.17,1.19,0l1.4.73c.33.17.32.45,0,.62Z",
    fill: "url(#eSvLbpigY9t201-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.64,180.84l1.67-.87c.33-.17.86-.17,1.19,0l1.34.7c.33.17.32.45,0,.62l-1.67.87c-.33.17-.86.17-1.19,0l-1.34-.7c-.33-.17-.33-.45,0-.62Z",
    fill: "url(#eSvLbpigY9t202-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.69,182.44l1.67-.87c.33-.17.86-.17,1.19,0l1.4.73c.33.17.32.45,0,.62l-1.67.87c-.33.17-.86.17-1.19,0l-1.4-.73c-.32-.17-.32-.45,0-.62Z",
    fill: "url(#eSvLbpigY9t203-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.79,184.06l1.67-.87c.33-.17.86-.17,1.19,0l1.39.73c.33.17.33.45,0,.62l-1.67.87c-.33.17-.86.17-1.19,0l-1.39-.73c-.33-.17-.33-.45,0-.62Z",
    fill: "url(#eSvLbpigY9t204-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.18,182.3l1.49-.78c.33-.17.87-.17,1.19,0l1.39.73c.33.17.32.45,0,.62l-1.5.78c-.33.17-.86.17-1.19,0l-1.39-.73c-.33-.17-.33-.45,0-.62Z",
    fill: "url(#eSvLbpigY9t205-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.65,178.93l1.21-.63c.33-.17.86-.17,1.19,0l1.39.73c.33.17.33.45,0,.62l-1.21.63c-.33.17-.87.17-1.19,0l-1.39-.73c-.33-.17-.33-.45,0-.62Z",
    fill: "url(#eSvLbpigY9t206-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.58,177.41l1.35-.7c.33-.17.86-.17,1.19,0l1.39.73c.32.17.32.45,0,.62l-1.35.7c-.33.17-.87.17-1.19,0l-1.39-.73c-.33-.17-.33-.45,0-.62Z",
    fill: "url(#eSvLbpigY9t207-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.18,166.03l-1.52.79c-.33.17-.86.17-1.19,0l-1.34-.7c-.33-.17-.33-.45,0-.62l1.52-.79c.33-.17.86-.17,1.19,0l1.34.7c.33.17.33.45,0,.62Z",
    fill: "url(#eSvLbpigY9t208-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.51,161.19c.33.17.32.45,0,.62l-1.52.79c-.33.17-.86.17-1.19,0l-1.4-.73c-.32-.17-.32-.45,0-.62l1.52-.79c.33-.17.86-.17,1.19,0l1.4.73Z",
    fill: "url(#eSvLbpigY9t209-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.99,156.76l-3.55,1.85c-.33.17-.86.17-1.19,0l-1.34-.7c-.33-.17-.32-.45,0-.62l3.55-1.85c.33-.17.86-.17,1.19,0l1.34.7c.33.17.32.45,0,.62Z",
    fill: "url(#eSvLbpigY9t210-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.94,155.17l-2.47,1.28c-.33.17-.86.17-1.19,0l-1.51-.79c-.33-.17-.32-.45,0-.62l2.47-1.28c.33-.17.86-.17,1.19,0l1.51.79c.33.17.32.45,0,.62Z",
    fill: "url(#eSvLbpigY9t211-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.41,159.81l2.21-1.15c.33-.17.86-.17,1.19,0l1.39.73c.33.17.32.45,0,.62l-2.21,1.15c-.33.17-.87.17-1.19,0l-1.39-.73c-.33-.17-.33-.45,0-.62Z",
    fill: "url(#eSvLbpigY9t212-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.27,153.61l-1.52.79c-.33.17-.86.17-1.19,0l-.22-.12c-.33-.17-.32-.45,0-.62l1.52-.79c.33-.17.86-.17,1.19,0l.22.12c.32.17.32.45,0,.62Z",
    fill: "url(#eSvLbpigY9t213-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.3,154.69l1.52-.79c.33-.17.86-.17,1.19,0l1.35.71c.32.17.32.45,0,.62l-1.52.79c-.33.17-.86.17-1.19,0l-1.35-.71c-.32-.17-.32-.45,0-.62Z",
    fill: "url(#eSvLbpigY9t214-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.25,155.93l1.51.79c.33.17.32.45,0,.62l-1.52.79c-.33.17-.86.17-1.19,0l-1.51-.79c-.33-.17-.32-.45,0-.62l1.52-.79c.33-.17.86-.17,1.19,0Z",
    fill: "url(#eSvLbpigY9t215-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.03,155.3l-1.34.7c-.33.17-.87.17-1.19,0l-.22-.12c-.33-.17-.32-.45,0-.62l1.34-.7c.33-.17.86-.17,1.19,0l.22.12c.33.17.32.45,0,.62Z",
    fill: "url(#eSvLbpigY9t216-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.96,156.9l-1.41.73c-.33.17-.86.17-1.19,0l-.22-.12c-.33-.17-.33-.45,0-.62l1.41-.73c.33-.17.86-.17,1.19,0l.22.12c.33.17.32.45,0,.62Z",
    fill: "url(#eSvLbpigY9t217-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.84,158.52l-1.38.72c-.33.17-.86.17-1.19,0l-.22-.12c-.33-.17-.32-.45,0-.62l1.38-.72c.33-.17.86-.17,1.19,0l.22.12c.32.17.32.45,0,.62Z",
    fill: "url(#eSvLbpigY9t218-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.74,160.14l-1.52.79c-.33.17-.86.17-1.19,0l-.22-.12c-.33-.17-.33-.45,0-.62l1.52-.79c.33-.17.86-.17,1.19,0l.22.12c.33.17.32.45,0,.62Z",
    fill: "url(#eSvLbpigY9t219-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.76,161.22l1.52-.79c.33-.17.87-.17,1.19,0l1.35.71c.32.17.32.45,0,.62l-1.52.79c-.33.17-.86.17-1.19,0l-1.35-.71c-.33-.17-.32-.45,0-.62Z",
    fill: "url(#eSvLbpigY9t220-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.01,159.53l1.38-.72c.33-.17.86-.17,1.19,0l1.35.71c.33.17.32.45,0,.62l-1.38.72c-.33.17-.86.17-1.19,0l-1.35-.71c-.32-.17-.32-.45,0-.62Z",
    fill: "url(#eSvLbpigY9t221-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.11,157.92l1.41-.73c.33-.17.86-.17,1.19,0l1.35.71c.33.17.32.45,0,.62l-1.41.73c-.33.17-.86.17-1.19,0l-1.35-.71c-.33-.17-.32-.45,0-.62Z",
    fill: "url(#eSvLbpigY9t222-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.23,156.29l1.34-.7c.33-.17.86-.17,1.19,0l1.35.71c.32.17.32.45,0,.62l-1.34.7c-.33.17-.86.17-1.19,0l-1.35-.71c-.32-.17-.32-.45,0-.62Z",
    fill: "url(#eSvLbpigY9t223-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.47,158.32l1.35-.7c.33-.17.86-.17,1.19,0l1.51.79c.33.17.33.45,0,.62l-1.35.7c-.33.17-.86.17-1.19,0l-1.51-.79c-.33-.17-.32-.45,0-.62Z",
    fill: "url(#eSvLbpigY9t224-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.72,158.88c.33.17.33.45,0,.62l-1.52.79c-.33.17-.86.17-1.19,0l-1.34-.7c-.33-.17-.32-.45,0-.62l1.52-.79c.33-.17.86-.17,1.19,0l1.34.7Z",
    fill: "url(#eSvLbpigY9t225-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.09,158.39l-4.86,2.53c-.33.17-.86.17-1.19,0l-1.39-.73c-.33-.17-.32-.45,0-.62l4.87-2.53c.33-.17.86-.17,1.19,0l1.4.73c.33.17.32.45,0,.62Z",
    fill: "url(#eSvLbpigY9t226-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.48,160.57c.33.17.32.45,0,.62l-1.35.7c-.33.17-.86.17-1.19,0l-1.34-.7c-.33-.17-.32-.45,0-.62l1.34-.7c.33-.17.86-.17,1.19,0l1.34.7Z",
    fill: "url(#eSvLbpigY9t227-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.67,169.66l1.52-.79c.33-.17.86-.17,1.19,0l1.51.79c.33.17.32.45,0,.62l-1.52.79c-.33.17-.86.17-1.19,0l-1.51-.79c-.33-.17-.32-.45,0-.62Z",
    fill: "url(#eSvLbpigY9t228-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.49,161.82l-1.35.7c-.33.17-.87.17-1.19,0l-.22-.12c-.33-.17-.33-.45,0-.62l1.35-.7c.33-.17.86-.17,1.19,0l.22.12c.32.17.32.45,0,.62Z",
    fill: "url(#eSvLbpigY9t229-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.43,163.42l-1.4.73c-.33.17-.86.17-1.19,0l-.22-.12c-.33-.17-.32-.45,0-.62l1.4-.73c.33-.17.86-.17,1.19,0l.22.12c.33.17.32.45,0,.62Z",
    fill: "url(#eSvLbpigY9t230-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.57,164.44l1.4-.73c.33-.17.86-.17,1.19,0l1.35.71c.33.17.32.45,0,.62l-1.4.73c-.33.17-.86.17-1.19,0l-1.35-.71c-.33-.17-.32-.45,0-.62Z",
    fill: "url(#eSvLbpigY9t231-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.81,166.47l1.4-.73c.33-.17.86-.17,1.19,0l1.51.79c.33.17.33.45,0,.62l-1.4.73c-.33.17-.86.17-1.19,0l-1.51-.79c-.33-.17-.32-.45,0-.62Z",
    fill: "url(#eSvLbpigY9t232-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.3,165.05l-1.18.61c-.33.17-.86.17-1.19,0l-.22-.12c-.33-.17-.33-.45,0-.62l1.18-.61c.33-.17.86-.17,1.19,0l.22.12c.33.17.32.45,0,.62Z",
    fill: "url(#eSvLbpigY9t233-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.67,165.95l1.18-.61c.33-.17.86-.17,1.19,0l1.35.71c.32.17.32.45,0,.62l-1.18.61c-.33.17-.86.17-1.19,0l-1.35-.71c-.33-.17-.32-.45,0-.62Z",
    fill: "url(#eSvLbpigY9t234-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.91,167.97l1.18-.61c.33-.17.86-.17,1.19,0l1.51.79c.33.17.32.45,0,.62l-1.18.61c-.33.17-.86.17-1.19,0l-1.51-.79c-.33-.17-.32-.45,0-.62Z",
    fill: "url(#eSvLbpigY9t235-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.34,159.94l1.4-.73c.33-.17.86-.17,1.19,0l1.51.79c.33.17.33.45,0,.62l-1.41.73c-.33.17-.86.17-1.19,0l-1.51-.79c-.33-.17-.32-.45,0-.62Z",
    fill: "url(#eSvLbpigY9t236-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.24,161.56l1.38-.72c.33-.17.86-.17,1.19,0l1.51.79c.33.17.33.45,0,.62l-1.38.72c-.33.17-.86.17-1.19,0l-1.51-.79c-.32-.17-.32-.45,0-.62Z",
    fill: "url(#eSvLbpigY9t237-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.41,162.79l-1.41.73c-.33.17-.86.17-1.19,0l-1.34-.7c-.33-.17-.32-.45,0-.62l1.41-.73c.33-.17.86-.17,1.19,0l1.33.7c.33.17.33.45,0,.62Z",
    fill: "url(#eSvLbpigY9t238-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.7,162.81l1.35-.7c.33-.17.86-.17,1.19,0l1.35.71c.33.17.32.45,0,.62l-1.35.7c-.33.17-.86.17-1.19,0l-1.35-.71c-.33-.17-.33-.45,0-.62Z",
    fill: "url(#eSvLbpigY9t239-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.27,163.5l-1.35.7c-.33.17-.86.17-1.19,0l-1.4-.73c-.33-.17-.32-.45,0-.62l1.35-.7c.33-.17.86-.17,1.19,0l1.4.73c.33.17.33.45,0,.62Z",
    fill: "url(#eSvLbpigY9t240-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246,163.25l1.52-.79c.33-.17.86-.17,1.19,0l1.51.79c.33.17.32.45,0,.62l-1.52.79c-.33.17-.86.17-1.19,0l-1.51-.79c-.32-.17-.32-.45,0-.62Z",
    fill: "url(#eSvLbpigY9t241-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.28,164.41l-1.38.72c-.33.17-.86.17-1.19,0l-1.34-.7c-.33-.17-.33-.45,0-.62l1.38-.72c.33-.17.86-.17,1.19,0l1.34.7c.33.17.33.45,0,.62Z",
    fill: "url(#eSvLbpigY9t242-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.2,165.1l-1.4.73c-.33.17-.87.17-1.19,0l-1.4-.73c-.33-.17-.32-.45,0-.62l1.4-.73c.33-.17.86-.17,1.19,0l1.4.73c.33.17.33.45,0,.62Z",
    fill: "url(#eSvLbpigY9t243-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.97,164.72l1.41-.73c.33-.17.86-.17,1.19,0l1.39.73c.32.17.32.45,0,.62l-1.41.73c-.33.17-.86.17-1.19,0l-1.39-.73c-.33-.17-.32-.45,0-.62Z",
    fill: "url(#eSvLbpigY9t244-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.93,164.84l1.35-.7c.33-.17.86-.17,1.19,0l1.51.79c.33.17.33.45,0,.62l-1.35.7c-.33.17-.86.17-1.19,0l-1.51-.79c-.33-.17-.32-.45,0-.62Z",
    fill: "url(#eSvLbpigY9t245-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.08,166.72l-1.38.72c-.33.17-.86.17-1.19,0l-1.4-.73c-.32-.17-.32-.45,0-.62l1.38-.72c.33-.17.86-.17,1.19,0l1.4.73c.33.17.32.45,0,.62Z",
    fill: "url(#eSvLbpigY9t246-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.87,166.33l1.38-.72c.33-.17.86-.17,1.19,0l1.39.73c.33.17.33.45,0,.62l-1.38.72c-.33.17-.87.17-1.19,0l-1.39-.73c-.33-.17-.32-.45,0-.62Z",
    fill: "url(#eSvLbpigY9t247-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.94,167.71l-1.35.7c-.33.17-.86.17-1.19,0l-1.34-.7c-.33-.17-.32-.45,0-.62l1.35-.7c.33-.17.86-.17,1.19,0l1.34.7c.33.17.33.45,0,.62Z",
    fill: "url(#eSvLbpigY9t248-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.97,168.34l-1.52.79c-.33.17-.86.17-1.19,0l-1.4-.73c-.32-.17-.32-.45,0-.62l1.52-.79c.33-.17.86-.17,1.19,0l1.4.73c.33.17.33.45,0,.62Z",
    fill: "url(#eSvLbpigY9t249-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.87,169.31l-1.4.73c-.33.17-.86.17-1.19,0l-1.34-.7c-.33-.17-.33-.45,0-.62l1.4-.73c.33-.17.86-.17,1.19,0l1.34.7c.33.17.33.45,0,.62Z",
    fill: "url(#eSvLbpigY9t250-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.73,170.02l-1.35.7c-.33.17-.86.17-1.19,0l-1.4-.73c-.33-.17-.32-.45,0-.62l1.35-.7c.33-.17.86-.17,1.19,0l1.4.73c.33.17.33.45,0,.62Z",
    fill: "url(#eSvLbpigY9t251-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.75,170.93l-1.18.62c-.33.17-.86.17-1.19,0l-1.34-.7c-.33-.17-.33-.45,0-.62l1.18-.61c.33-.17.86-.17,1.19,0l1.34.7c.33.17.32.45,0,.62Z",
    fill: "url(#eSvLbpigY9t252-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.67,171.62l-1.4.73c-.33.17-.87.17-1.19,0l-1.4-.73c-.33-.17-.32-.45,0-.62l1.4-.73c.33-.17.86-.17,1.19,0l1.4.73c.33.17.32.45,0,.62Z",
    fill: "url(#eSvLbpigY9t253-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.54,173.24l-1.18.61c-.33.17-.86.17-1.19,0l-1.4-.73c-.32-.17-.32-.45,0-.62l1.18-.61c.33-.17.87-.17,1.19,0l1.4.73c.33.17.33.45,0,.62Z",
    fill: "url(#eSvLbpigY9t254-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.64,175.82l16.51-8.59c.33-.17.86-.17,1.19,0l1.39.73c.33.17.33.45,0,.62l-16.51,8.59c-.33.17-.87.17-1.19,0l-1.39-.73c-.33-.17-.33-.45,0-.62Z",
    fill: "url(#eSvLbpigY9t255-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.16,161.5l1.52-.79c.33-.17.86-.17,1.19,0l1.39.73c.33.17.33.45,0,.62l-1.52.79c-.33.17-.86.17-1.19,0l-1.39-.73c-.33-.17-.33-.45,0-.62Z",
    fill: "url(#eSvLbpigY9t256-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.1,163.09l1.34-.7c.33-.17.87-.17,1.19,0l1.39.73c.33.17.33.45,0,.62l-1.34.7c-.33.17-.87.17-1.19,0l-1.39-.73c-.33-.17-.32-.45,0-.62Z",
    fill: "url(#eSvLbpigY9t257-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.64,151.86l-1.65.86c-.33.17-.87.17-1.19,0l-.22-.12c-.33-.17-.33-.45,0-.62l1.65-.86c.33-.17.86-.17,1.19,0l.22.12c.33.17.32.45,0,.62Z",
    fill: "url(#eSvLbpigY9t258-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.72,153.48l-1.65.86c-.33.17-.87.17-1.19,0l-1.35-.71c-.33-.17-.32-.45,0-.62l1.65-.86c.33-.17.86-.17,1.19,0l1.35.71c.32.17.32.45,0,.62Z",
    fill: "url(#eSvLbpigY9t259-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.43,167.63l1.52-.79c.33-.17.86-.17,1.19,0l1.35.71c.33.17.32.45,0,.62l-1.52.79c-.33.17-.86.17-1.19,0l-1.35-.71c-.32-.17-.32-.45,0-.62Z",
    fill: "url(#eSvLbpigY9t260-fill)"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M242.48,178.53l20.48-10.65c.25-.13.65-.13.89,0l9.6,5.03c.25.13.24.34,0,.47l-20.47,10.65c-.25.13-.65.13-.89,0l-9.6-5.03c-.25-.13-.24-.34,0-.47Z",
    fill: "url(#eSvLbpigY9t261-fill)"
  }))), /*#__PURE__*/React.createElement("g", null, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M281.9,333.87c0,0-6.94,3.65-12.09,5.21s-6.75,1.69-7.44,2.93-1.32,3.63,1.25,4.43s20.33,2.87,23.19,3.21c2.86.35,8.99-.65,9.06-2.84s-2.1-12.81-2.1-12.81l-11.87-.14Z",
    fill: "#c27d5d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.06,332.46c0,0-6.94,3.65-12.1,5.21-5.15,1.55-6.75,1.69-7.43,2.93-.69,1.24-1.32,3.64,1.25,4.44s20.33,2.87,23.19,3.21c2.86.35,8.99-.65,9.07-2.84.07-2.19-2.1-12.81-2.1-12.81l-11.87-.14Z",
    fill: "#5274ab"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280,334.83c0,0,9.42,3.52,16.07-2.91c0,0-.47-21.11-.85-45.31c10.17-15.25,26.51-28.37,35.48-35.21l-35.98-15.67c0,0-17.78,25.61-20.54,46c.37,13.24,5.83,53.09,5.83,53.09Z",
    fill: "#1e202b"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M273.29,308.63c0,0-5.48,5.75-9.99,8.88s-6.03,3.75-6.24,5.19.07,4,2.91,4s21.19-3.42,24.16-3.96c2.96-.54,8.65-3.41,7.88-5.6s-6.93-12.02-6.93-12.02l-11.79,3.52Z",
    fill: "#c27d5d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.92,307.19c0,0-5.48,5.75-9.99,8.88s-6.03,3.75-6.24,5.19.07,4,2.91,4s21.19-3.42,24.15-3.96s8.65-3.41,7.88-5.6-6.93-12.02-6.93-12.02l-11.79,3.52Z",
    fill: "#5274ab"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.71,265.8c0,0,.18,3.83,5.08,11.54s18.95,30.96,18.95,30.96s10.54.75,15.16-4c0,0-14.7-33.84-17.01-38.5s-20.05-8.92-22.19,0Z",
    fill: "#2d3041"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "335.83,243.9 340.52,241.44 325.56,339.45 320.86,341.91 335.83,243.9",
    fill: "#7f5545"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "360.81,252 365.51,249.54 380.47,368.02 375.77,370.48 360.81,252",
    fill: "#976552"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "331.75,236.87 336.45,234.42 365.51,249.54 360.81,252 331.75,236.87",
    fill: "#9c6854"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "360.81,252 375.77,370.48 371,367.99 356.7,254.76 335.83,243.9 320.86,341.91 316.1,339.43 331.75,236.87 360.81,252",
    fill: "#614135"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    points: "280.37,327.75 326.67,303.53 325.98,308.07 279.68,332.28 280.37,327.75",
    fill: "#7f5545"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    points: "275.6,325.26 321.9,301.04 326.67,303.53 280.37,327.75 275.6,325.26",
    fill: "#9c6854"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    points: "280.37,327.75 279.68,332.28 274.91,329.8 275.6,325.26 280.37,327.75",
    fill: "#614135"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    points: "323.32,345.93 369.62,321.71 370.28,326.96 323.98,351.18 323.32,345.93",
    fill: "#976552"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    points: "318.55,343.45 364.85,319.23 369.62,321.71 323.32,345.93 318.55,343.45",
    fill: "#9c6854"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    points: "323.32,345.93 323.98,351.18 319.22,348.69 318.55,343.45 323.32,345.93",
    fill: "#614135"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    points: "287.39,269.24 292.08,266.78 277.12,364.79 272.42,367.25 287.39,269.24",
    fill: "#7f5545"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    points: "312.37,277.34 317.07,274.88 332.03,393.36 327.33,395.82 312.37,277.34",
    fill: "#976552"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    points: "283.31,262.22 288.01,259.76 317.07,274.88 312.37,277.34 283.31,262.22",
    fill: "#9c6854"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    points: "312.37,277.34 327.33,395.82 322.56,393.34 308.26,280.1 287.39,269.24 272.42,367.25 267.66,364.77 283.31,262.22 312.37,277.34",
    fill: "#614135"
  }))), /*#__PURE__*/React.createElement("g", null, _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    points: "370.86,248.4 370.86,254.79 314.04,284.64 314.04,278.26 370.86,248.4",
    fill: "#fcbb86"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    points: "370.86,248.4 314.04,278.26 280.88,261.35 337.69,231.49 370.86,248.4",
    fill: "#eda468"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    points: "314.04,278.26 314.04,284.64 280.88,267.74 280.88,261.35 314.04,278.26",
    fill: "#b57962"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      mixBlendMode: "overlay"
    },
    points: "280.88,261.35 280.88,262.35 314.04,279.26 370.86,249.4 370.86,248.4 314.04,278.26 280.88,261.35",
    opacity: 0.4,
    fill: "#fffbf7"
  })), /*#__PURE__*/React.createElement("g", null, _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    points: "370.86,248.4 370.86,254.79 314.04,284.64 314.04,278.26 370.86,248.4",
    fill: "#fcbb86"
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    points: "370.86,248.4 314.04,278.26 280.88,261.35 337.69,231.49 370.86,248.4",
    fill: "#eda468"
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    points: "314.04,278.26 314.04,284.64 280.88,267.74 280.88,261.35 314.04,278.26",
    fill: "#b57962"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      mixBlendMode: "overlay"
    },
    points: "280.88,261.35 280.88,262.35 314.04,279.26 370.86,249.4 370.86,248.4 314.04,278.26 280.88,261.35",
    opacity: 0.4,
    fill: "#fffbf7"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M294.67,233.88c0,0-31.35,14-37.82,17.33s-9.15,7.8-9.15,15.08c0,3.92,11.1,3.83,21.82,1.92c2.63-.47,6.67-1.1,11.38-1.83l.08-5.04l8.46-3.59c0,0,13.74,4.88,23.88,3.3c3.86-.76,6.96-1.47,8.72-2.09c7.77-2.75,15.9-6.58,17.75-13.83l-45.12-11.25Z",
    fill: "#2d3041"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M278.18,162.09c0,0-2.42-1.56-3.13-1.97-.71-.42-1.54-.79-2.36-.86s-3.19-.33-3.86-.49c-.68-.16-2.03-.67-2.24-.49-.22.18-.07,1.97,1.97,2.57c2.03.6,3.09.46,3.89.82.79.36,3.74,2.44,3.74,2.44l2-2.02Z",
    fill: "url(#eSvLbpigY9t303-fill)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.25,162.49c0,0-3.2-1.53-3.99-1.91s-1.7-.71-2.58-.72-3.4-.09-4.13-.21-2.2-.55-2.41-.34c-.21.2.12,2.09,2.32,2.56c2.21.47,3.32.24,4.19.56s4.19,2.29,4.19,2.29l2.42-2.22Z",
    fill: "url(#eSvLbpigY9t304-fill)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.48,163.9c0,0-3.58-1.4-4.46-1.75-.88-.36-1.89-.64-2.83-.58s-3.65.16-4.45.08c-.79-.07-2.42-.42-2.62-.19-.21.23.32,2.23,2.73,2.57s3.58.01,4.54.29s4.7,2.14,4.7,2.14l2.39-2.57Z",
    fill: "url(#eSvLbpigY9t305-fill)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.53,169.23l-2.58,5.95c0,0-8.11-1.88-12.64-2.58s-17.47-3.81-20.03-5.16c-2.57-1.34-7.61-5.03-8.09-5.35s-1.69-1.14-2.27-.86c-3.16,1.56-5.51,5.35-5.87,6.75.73,1.3,3.58,2.76,5.13,3.77s5.19,1.66,7.57,1.66s11.81,5,19.62,8.71s16.87,6.99,20.22,8.01c3.34,1.02,4.95.48,6.5-1.24s5.67-9.19,7.28-13.76l-14.83-5.9Z",
    fill: "#fdddc8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.81,173.18c0,0,4.33,7.19,12.16,11.21c1.64-2.93,3.45-6.6,4.39-9.27l-14.83-5.9-1.72,3.96Z",
    fill: "url(#eSvLbpigY9t307-fill)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.24,166.15c0,0-3.17-1.24-3.95-1.55s-1.68-.56-2.51-.51-3.24.14-3.94.07c-.7-.06-2.14-.37-2.32-.16s.29,1.98,2.42,2.28s3.17,0,4.03.25s4.16,1.89,4.16,1.89l2.11-2.27Z",
    fill: "#fdddc8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.33,168.35c.97,1.16,3.3,2.4,4.72,3.31c1.53-1.37,2.73-2.87,1.49-3.39-2.12-.89-5.28-.17-6.21.08Z",
    fill: "url(#eSvLbpigY9t309-fill)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.49,172.85c0,0-3.21-.29-5.16-.31-1.95-.01-2.57-.2-3.42-.53s-2.05-1.45-2.68-1.69-2.1-.62-2.05-1.07s1.92-1.3,3.71-.71c1.78.6,2.24.95,3.02.8.79-.15,2.27-1.5,4.39-1.14c2.13.36,3.61,3.44,2.18,4.64Z",
    fill: "#fdddc8",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M332.35,102.42c-8.76-.33-13.59,3.31-16.09,10.69s-.9,8.56-2.91,12.5-1.46,7.31.35,11.62c1.8,4.31,2.57,6.25,4.23,6.25s6.52-1.12,6.52-1.12l17.61-2.25c0,0,7.21-6,9.36-19.75c2.12-13.57-7.49-17.5-19.07-17.94Z",
    fill: "#fdddc8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.28,138.93c0,0,.13,10.68-4.03,16.75-4.16,6.06-6.1,6.44-6.1,6.44s12.2,5.75,23.47,1.38c11.27-4.38,11.27-14.25,11.27-14.25s-9.02-.56-6.31-14.56l-12.25-1.58c0,0-1.17,2.23-5.33,3.29-.49.7-.7,1.58-.73,2.54Z",
    fill: "url(#eSvLbpigY9t313-fill)",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M321.25,155.67c0,0-7.7,6.19-10.47,8.12-2.77,1.94-9.99,6.81-10.96,16.75s.62,33.69-2.64,43.12c-3.26,9.44-5.48,9.5-3.74,15c1.73,5.5,10.75,12.94,25.59,14.56s24.62-5,26.49-16.25s4.72-32.31,6.66-42.5s8.05-25.81,6.84-34.06c-.42-2.9-1.42-6.14-2.63-8.08-2.23-3.59-9.09-4.33-9.69-4.33-.93,0-1.82.83-9.49,2.83s-11.38,2.75-15.96,4.83Z",
    fill: "#5274ab"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.43,148.08c0,0-3.18-4.34-3.77-4.37-.58-.04-8.54,1.08-15.05,4.05-6.59,3.01-8.79,9.06-8.79,9.06s16.55-5.48,27.61-8.74Z",
    fill: "#395075"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.48,217.64c10.41-6.85,17.79-20.69,19.44-31.39l-18.46,4.05c-.08,8.69.05,19.57-.98,27.34Z",
    fill: "#3c547d"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M253.2,185.42c0,0-.98-2.77-1.4-4.49s-.75-2.23-1.28-2.9c-.54-.67-2-1.51-2.39-2.02s-1.1-1.72-1.58-1.59c-.48.14-1.01,1.96,0,3.41s1.49,1.77,1.49,2.5-1.16,2.31-.33,4.11s4.47,2.47,5.48.97Z",
    fill: "url(#eSvLbpigY9t320-fill)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.99,187.77l-4.02,5.95c0,0-8.11-1.88-12.64-2.58s-17.47-3.82-20.04-5.16c-2.56-1.34-6.98-7.47-7.45-7.79-.48-.32-1.69-1.14-2.27-.86-3.16,1.56-6.14,7.79-6.5,9.19.73,1.3,3.58,2.76,5.13,3.77s5.19,1.66,7.57,1.66s11.81,5,19.62,8.71s16.88,6.99,20.21,8.01c3.34,1.02,4.95.48,6.5-1.24s5.66-9.19,7.28-13.76l-13.4-5.89Z",
    fill: "#fdddc8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M255.13,189.1c0,0-.68,1.88-.62,3.6l2.13,1.04c0,0,.28-2.24,1.17-3.82l-2.68-.82Z",
    fill: "#cf8f5b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.84,188.73c-.2,1.06-1.8,1.69-3.56,1.42s-3.03-1.36-2.82-2.41c.2-1.06,1.8-1.7,3.56-1.42s3.03,1.36,2.83,2.42Z",
    fill: "#7d4a41",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.27,188.44c-.17.87-1.48,1.39-2.93,1.17s-2.49-1.12-2.33-1.99c.17-.87,1.48-1.39,2.93-1.17c1.45.23,2.49,1.12,2.33,1.99Z",
    fill: "#d9c8c5",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M246.42,177.39c0,0-3.07-1.42-3.83-1.78s-1.63-.66-2.47-.66-3.24-.05-3.94-.16-2.11-.5-2.31-.3.14,1.99,2.25,2.42s3.16.2,4,.49c.83.29,4.01,2.14,4.01,2.14l2.28-2.14Z",
    fill: "#fdddc8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.57,179.51c0,0-3.58-1.4-4.46-1.75s-1.89-.64-2.83-.58c-.94.05-3.65.16-4.45.08-.79-.08-2.42-.43-2.62-.19-.21.24.32,2.23,2.73,2.57s3.58,0,4.54.29c.96.28,4.7,2.14,4.7,2.14l2.39-2.56Z",
    fill: "#fdddc8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.73,182.11c0,0-3.45-1-4.3-1.25-.85-.26-1.81-.43-2.68-.3-.86.13-3.36.45-4.1.44-.74,0-2.28-.2-2.45.04-.17.23.52,2.04,2.79,2.15c2.26.12,3.31-.28,4.23-.11.92.18,4.57,1.59,4.57,1.59l1.95-2.57Z",
    fill: "#fdddc8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.99,184.84c0,0-3.33-.7-4.15-.88s-1.74-.28-2.54-.1-3.12.66-3.82.71-2.16-.02-2.3.21.67,1.88,2.81,1.83s3.09-.5,3.97-.4s4.43,1.18,4.43,1.18l1.61-2.55Z",
    fill: "#fdddc8",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M305.84,167.84c0,0-6.09,7.08-9,11.02s-9.78,13.31-9.78,13.31-1.52-.64-2.48-.59c-1.06,2.59-2.8,7.75-2.05,14.86c1.62.79,4.93,2.79,6.92,3.73c2.13,1,5.22,2.17,6.8.5c1.57-1.67,4.48-4.08,6.75-6.79s13.13-8.3,15.07-18.3c1.94-9.99-5.95-23.91-12.22-17.75Z",
    fill: "#5274ab"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.42,191.94c0,0-.12-.65-.46-.74-.35-.09-8.39-.16-8.81-.16s-1.91.97-2.77,4.78c-.87,3.81-.42,6.69,0,7.09.42.41,8.32,4.57,8.59,4.69s1.16-.28,1.16-.28-1.29-7.64,2.3-15.38Z",
    fill: "#7495cc"
  })))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M319.04,115.3c0,0-1.85,3.37-1.11,6.67c0,0,1.34-.58,2.17-1.58c0,0,.42,2.75.46,3.12.05.38,1.9,1.58,2.03,2.33s.28,4.83.28,4.83l1.43.21c0,0,1.14-2.88,1.7-3.62s2.37-2,3.15-1.25c.79.75,1.2,5.25.6,7.21s-3.75,3.17-3.75,3.17c.06,3.96,1.31,5.5,1.68,5.71s.92-.96.92-.96s6.43,2.78,9.02,2.58s7.81-2.12,10.45-7.24c0,0,.6,1.04.79,1.04s5.69-4.17,7.07-11.58c1.39-7.42-1.11-10.92-2.87-13.54.14-4.12-1.15-8.33-6.66-10.17-5.5-1.83-10.5-2.54-12.76-4.42s-5.73-4.75-6.38-4.54-3.7,2.38-3.65,5.79c-3.28-1.12-6.84-4-7.26-2.67s-2.59,7.25,0,11.21c-1.99-.54-3.61-.54-3.61.12s.93,6.25,6.29,7.58Z",
    fill: "#6f4d50"
  }))), /*#__PURE__*/React.createElement("g", null, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M192.03,195.42l.28-.15c-.08.04-.15.1-.2.17-.1.16-.23.29-.4.38l-.28.15c.16-.09.3-.22.4-.38.04-.07.11-.12.19-.17Z",
    fill: "#2c3340"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.28,199.22 206.56,199.07 206.56,199.99 206.28,200.13 206.28,199.22",
    fill: "url(#eSvLbpigY9t336-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.28,199.22v.92c-.39-.13-7.88-2.54-8.62-2.75-.1-.03-.2-.07-.31-.12-.27-.14-.57-.37-.9-.61s-.7-.5-1.12-.72c-.23-.12-.47-.22-.72-.3-1.36-.42-2.49-.47-2.77-.05-.28.43-.77.68-1.54.28s-1.2-1.15-1.13-1.26s5.03.17,5.5.36c.47.18,11.05,4.05,11.61,4.25Z",
    fill: "url(#eSvLbpigY9t337-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.18,194.61l.28-.15c.19-.1,5.03.18,5.49.36.47.18,11.05,4.05,11.61,4.25l-.28.15c-.56-.2-11.14-4.07-11.61-4.25-.46-.18-5.3-.46-5.49-.36Z",
    fill: "#697a9c"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M208.5,186.96l.28-.15c-.08.04-.15.1-.19.17-.1.16-.23.29-.4.38l-.28.15c.16-.09.3-.22.4-.38.04-.07.11-.12.19-.17Z",
    fill: "#2c3340"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.74,190.76 223.03,190.61 223.03,191.53 222.74,191.68 222.74,190.76",
    fill: "url(#eSvLbpigY9t341-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.74,190.76v.92c-.39-.13-7.88-2.54-8.62-2.75-.1-.03-.2-.07-.31-.12-.27-.14-.57-.37-.9-.61s-.7-.5-1.12-.72c-.23-.12-.47-.22-.72-.3-1.36-.42-2.49-.47-2.77-.04s-.77.68-1.54.28-1.2-1.15-1.13-1.26s5.03.17,5.5.36c.47.18,11.05,4.05,11.61,4.25Z",
    fill: "url(#eSvLbpigY9t342-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.64,186.15l.28-.15c.19-.1,5.03.18,5.49.36.47.18,11.05,4.05,11.61,4.25l-.28.15c-.56-.2-11.14-4.07-11.61-4.25-.46-.18-5.3-.46-5.49-.36Z",
    fill: "#697a9c"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M221.93,192.22c-.05-.08-.11-.16-.21-.21-.13-.07-.27-.14-.4-.21c0,0-.01,0-.02-.01.1.05.16.13.21.21.13.21.19,1.21-.15,2.56-.28,1.12-1.05,2.09-2.36,2.77-.28.14-.57.27-.9.39-.66.24-1.15.2-1.51.01l.42.22c.36.19.85.23,1.51-.01.32-.12.62-.25.9-.39c1.32-.69,2.08-1.65,2.36-2.77.34-1.35.28-2.35.15-2.57Z",
    fill: "url(#eSvLbpigY9t345-fill)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M216.77,198.35l-.42-.22c-.81-.43-1.07-1.69-1.36-1.96-.01,0-.02-.02-.04-.03l.42.22c0,0,.03.02.04.03.29.27.54,1.53,1.36,1.96Z",
    fill: "#2c3340"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M213.55,196.35l-.42-.22c.2.11.31.4.27,1-.07.96-.57,3.05-2.44,4.31-.32.22-.62.4-.9.54-.85.44-1.47.53-1.88.32.14.07.28.15.42.22.41.21,1.03.13,1.89-.32.28-.14.57-.32.9-.54c1.87-1.27,2.36-3.35,2.44-4.32.05-.61-.06-.9-.27-1Z",
    fill: "url(#eSvLbpigY9t347-fill)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M208.3,202.92c-.14-.07-.28-.15-.42-.22-.5-.26-.67-.87-.77-1.25-.12-.46-.13-1.1-.38-1.23l.42.22c.25.13.26.78.37,1.23.1.38.27.99.77,1.25Z",
    fill: "#2c3340"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M222.84,190.38c0,0-.06-.01-.11,0-.15.02-2.02.75-3.53,1.53-.08.05-.17.09-.25.13-1.54.83-2.71,1.77-3.12,2.06-.41.3-.88.66-1.32.89s-.92.36-1.33.49-1.59.41-3.12,1.19c-.08.04-.16.08-.25.12-1.5.78-3.38,2.01-3.53,2.14-.15.14-.15.2-.15.38s0,.61,0,.8c0,.07.01.11.04.12.14.07.28.15.42.22-.03-.02-.04-.05-.04-.12c0-.2,0-.63,0-.8c0-.18,0-.23.15-.38.15-.13,2.02-1.36,3.53-2.14.08-.04.17-.09.24-.12c1.54-.77,2.72-1.06,3.13-1.19s.88-.26,1.33-.49c.44-.23.91-.59,1.33-.89.41-.3,1.58-1.23,3.12-2.06.08-.05.16-.09.25-.13c1.51-.78,3.38-1.51,3.53-1.53.05,0,.09,0,.11,0l-.42-.22Z",
    fill: "url(#eSvLbpigY9t349-fill)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M219.63,192.13c-.08.04-.16.09-.25.13-1.54.83-2.71,1.77-3.12,2.06-.41.3-.88.66-1.33.89-.44.23-.92.36-1.33.49s-1.59.41-3.13,1.19c-.08.04-.16.08-.24.12-1.5.78-3.38,2.01-3.53,2.14-.15.14-.15.2-.15.38s0,.61,0,.8.08.13.46.08c.37-.05.37.73.5,1.25.14.52.42,1.5,1.51,1.36.46-.06,1-.24,1.56-.54.78-.41,1.59-1.02,2.21-1.8c1.07-1.34,1.33-3.17,1.65-3.8.13-.26.38-.4.49-.46.07-.04.32-.15.45-.04.33.3.6,1.85,1.67,2.07.62.13,1.43-.1,2.22-.5.56-.29,1.11-.68,1.56-1.09c1.09-1,1.36-2.26,1.5-2.92.13-.67.12-1.43.5-1.77s.46-.36.46-.56c0-.19,0-.63,0-.8s0-.23-.16-.21c-.15.02-2.02.75-3.53,1.53Zm2.15,2.66c-.28,1.12-1.05,2.08-2.36,2.77-.28.14-.57.27-.9.39-1.87.68-2.38-.88-2.46-1.77-.08-.88.24-1.39.69-1.75c1.07-.86,1.9-1.39,2.58-1.75.57-.29,1.04-.47,1.48-.62.75-.25.98-.05,1.11.16s.19,1.21-.15,2.57m-7.97,2.56c-.07.96-.57,3.05-2.44,4.32-.32.22-.62.4-.9.54-1.32.69-2.09.52-2.37-.3-.34-1-.29-2.06-.16-2.41s.35-.78,1.1-1.31c.43-.31.91-.62,1.48-.92.68-.36,1.51-.69,2.59-.94.45-.11.78.06.7,1.02",
    fill: "url(#eSvLbpigY9t350-fill)"
  })))), /*#__PURE__*/React.createElement("g", null, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M195.06,206.08c.2-1.37.4-2.73.6-4.1-.12.82-.77,1.62-1.94,2.26-2.69,1.46-7.15,1.5-9.95.09-1.31-.66-2.02-1.51-2.15-2.38.19,1.37.38,2.74.58,4.1.11.8.77,1.58,1.97,2.19c2.57,1.29,6.65,1.25,9.11-.08c1.07-.58,1.67-1.32,1.78-2.07Z",
    fill: "url(#eSvLbpigY9t352-fill)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M195.67,201.98c.42-2.88.84-5.75,1.26-8.62-.14.96-.9,1.91-2.28,2.66-3.17,1.72-8.41,1.77-11.71.11-1.54-.77-2.38-1.78-2.53-2.81l1.21,8.63c.12.88.84,1.73,2.15,2.39c2.81,1.41,7.27,1.37,9.96-.09c1.18-.64,1.82-1.44,1.94-2.26Z",
    fill: "#7dd075"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M196.93,193.36c.08-.54.16-1.08.24-1.62-.15.99-.93,1.96-2.35,2.73-3.26,1.77-8.65,1.82-12.04.11-1.58-.79-2.45-1.83-2.6-2.88.08.54.15,1.08.23,1.63.14,1.03.99,2.03,2.53,2.81c3.3,1.66,8.54,1.61,11.71-.11c1.38-.75,2.14-1.69,2.28-2.66Z",
    fill: "url(#eSvLbpigY9t354-fill)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M181.73,184.75c-3.69,2-3.56,5.18.28,7.12c3.84,1.93,9.94,1.88,13.63-.12s3.56-5.19-.28-7.12-9.95-1.88-13.63.12Z",
    fill: "url(#eSvLbpigY9t355-fill)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M184.46,184.47c2.24-1.21,5.95-1.25,8.28-.08s2.41,3.11.17,4.32-5.95,1.25-8.28.07c-2.33-1.17-2.41-3.11-.17-4.32Z",
    fill: "url(#eSvLbpigY9t356-fill)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M187.22,186.08c.78-.42,2.06-.43,2.87-.03.81.41.84,1.08.06,1.5s-2.06.43-2.87.03c-.81-.41-.84-1.08-.06-1.5Z",
    fill: "#363e4f"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M186.82,185.65c.99-.54,2.63-.55,3.67-.03c1.03.52,1.07,1.38.08,1.91-.99.54-2.63.55-3.66.03s-1.07-1.38-.08-1.91Zm.46,1.93c.81.41,2.1.39,2.87-.03.78-.42.75-1.09-.06-1.5s-2.1-.4-2.87.03-.75,1.09.06,1.5Z",
    fill: "url(#eSvLbpigY9t358-fill)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M194.92,185.86c-.51-.36-1.01-.71-1.52-1.07c1.67,1.18,1.52,2.84-.49,3.93-2.24,1.21-5.95,1.25-8.28.07-2.15-1.08-2.38-2.81-.65-4.03-.51.36-1.02.71-1.52,1.06-2.3,1.61-1.99,3.9.86,5.33c3.09,1.55,7.99,1.51,10.95-.1c2.65-1.44,2.85-3.64.64-5.2Z",
    fill: "url(#eSvLbpigY9t359-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M184.64,188.79c2.33,1.17,6.04,1.14,8.28-.07c1.64-.89,2.03-2.16,1.22-3.24.91,1.1.54,2.42-1.14,3.34-2.24,1.21-5.95,1.25-8.28.08-.62-.31-1.08-.68-1.38-1.07.3.35.73.69,1.3.97Z",
    opacity: 0.4,
    fill: "#fff"
  }), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M198.32,191.4c0-1.04,0-2.09,0-3.13c0,1.25-.89,2.5-2.68,3.47-3.69,2-9.79,2.06-13.63.12-1.98-.99-2.97-2.32-2.97-3.65c0,1.04,0,2.09,0,3.13c0,1.32.99,2.65,2.97,3.64c3.84,1.93,9.94,1.88,13.63-.12c1.79-.97,2.68-2.22,2.68-3.47Z",
    fill: "url(#eSvLbpigY9t361-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M182.01,191.87c3.84,1.93,9.94,1.88,13.63-.12c1.79-.97,2.68-2.22,2.68-3.46c0,.05,0,.09,0,.14c0,1.25-.89,2.5-2.68,3.47-3.69,2-9.79,2.06-13.63.12-1.98-.99-2.97-2.32-2.97-3.64v-.15c0,1.33.99,2.65,2.97,3.65Z",
    opacity: 0.4,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "93.58,282.05 118.95,295.34 111.06,341.9 93.56,332.73 75.94,341.9 68.04,295.34 93.58,282.05",
    fill: "#8c5e4c"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.37,315.1 93.41,355.53 119.62,341.9 131.35,295.34 93.37,315.1",
    fill: "url(#eSvLbpigY9t366-fill)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.64,295.34 67.38,341.9 93.41,355.53 93.37,315.1 55.64,295.34",
    fill: "url(#eSvLbpigY9t367-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "120.99,336.46 119.62,341.9 93.41,355.53 93.4,355.52 93.4,350.82 120.99,336.46",
    fill: "#eda468"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.01,336.47 93.4,350.82 93.4,355.52 67.38,341.9 66.01,336.47",
    fill: "#b57962"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "93.37,315.98 55.9,296.35 55.64,295.34 93.37,315.1 131.35,295.34 131.1,296.35 93.37,315.98",
    opacity: 0.3,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.62,275.58L55.64,295.34L93.37,315.1l37.98-19.76-37.73-19.76Zm-.21,33.05L68.04,295.34l25.54-13.29l25.37,13.29-25.54,13.29",
    fill: "#c8c8e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.28,307.35c-.35,0-.72,0-1.12-.02-2.98-.32-4.52-1.47-5.99-2.73l17.78-9.25-15.21-7.96c2.5-.54,4.63.26,7.78-2.09.1-.06.17-.13.26-.19l19.56,10.25-23.07,12.01Z",
    fill: "#acacd1"
  }))), /*#__PURE__*/React.createElement("g", null, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M117.87,232.2c-.99-5.97,1.39-6.01-.69-12.05-2.41-5.97-5.63-8.29-8.4-13.99-4.55,4.68-8.41,5.99-12.71,11.03-4.02,5.18-1.76,5.87-4.72,11.29-2.66,5.52-5.51,4.96-7.88,10.77-2.06,5.9,1.34,6.32.32,12.22-.71,5.94-4.64,5.78-4.99,11.96-.02,6.19,4.39,6.08,5.38,12.05c1.3,5.95-3.53,6.41-1.76,12.51c2.1,6.04,7.3,5.21,10.36,10.82c4.81-4.51,9.48-2.29,13.52-7.47c3.74-5.32-.71-7.09,2.54-12.4c2.95-5.41,7.12-4.11,9.18-10.01c1.76-5.97-2.04-6.9-.72-12.76c1.02-5.9,4.4-5.36,4.43-11.55-.29-6.19-3.2-6.43-3.87-12.42Z",
    fill: "url(#eSvLbpigY9t375-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M78.81,263.43c.26-4.74,2.64-5.76,4.05-8.66.2.63.48,1.32.93,2.12c2.4,4.79,5.64,3.68,7.79,8.75c1.9,5.16-1.81,6.16-.83,11.39.72,5.28,4.9,4.48,5.27,10.01.07,4.79-3.32,5.9-4.81,9.58-3.04-3.32-7.02-3.53-8.79-8.63-1.77-6.09,3.06-6.56,1.76-12.51-.99-5.97-5.4-5.86-5.38-12.05Z",
    fill: "#a9d1b5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M118.58,235.41c-2.47,2.92-1.42,4.06-4.31,7.88-3.07,4.5-5.48,3.7-8.33,8.5-2.6,4.91.31,5.64-1.39,10.67-1.43,5.09-4.83,4.52-5.97,9.85-.86,5.38,2.99,5.78,3.03,11.08.32,5.32-3.95,5.19-3.24,10.69.11.58.26,1.08.44,1.55c2.64-.77,5.17-1.31,7.49-4.29c3.74-5.32-.71-7.09,2.54-12.4c2.95-5.41,7.12-4.11,9.18-10.01c1.76-5.97-2.04-6.9-.72-12.76c1.02-5.9,4.4-5.36,4.43-11.55-.23-4.84-2.05-6.05-3.16-9.21Z",
    fill: "#a9d1b5"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eSvLbpigY9t388)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }, _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 109.3,
    y1: 203.13,
    x2: 92.19,
    y2: 302.27,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _polyline19 || (_polyline19 = /*#__PURE__*/React.createElement("polyline", {
    points: "122.72,278.81 93.78,293.07 71.02,271.56",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _polyline20 || (_polyline20 = /*#__PURE__*/React.createElement("polyline", {
    points: "125.36,263.47 96.43,277.73 73.66,256.22",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _polyline21 || (_polyline21 = /*#__PURE__*/React.createElement("polyline", {
    points: "128.01,248.13 99.08,262.38 76.31,240.88",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _polyline22 || (_polyline22 = /*#__PURE__*/React.createElement("polyline", {
    points: "130.66,232.79 101.73,247.04 78.96,225.54",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _polyline23 || (_polyline23 = /*#__PURE__*/React.createElement("polyline", {
    points: "133.31,217.45 104.37,231.7 81.61,210.2",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _polyline24 || (_polyline24 = /*#__PURE__*/React.createElement("polyline", {
    points: "135.96,202.1 107.02,216.36 84.26,194.85",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "eSvLbpigY9t388"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.79,298.81c-3.06-5.61-8.26-4.78-10.36-10.82-1.77-6.09,3.06-6.56,1.76-12.51-.99-5.97-5.4-5.86-5.38-12.05.34-6.17,4.27-6.01,4.99-11.96c1.02-5.9-2.39-6.32-.32-12.22c2.36-5.82,5.22-5.26,7.88-10.77c2.96-5.42.7-6.11,4.72-11.29c4.31-5.03,8.16-6.35,12.71-11.03c2.76,5.7,5.99,8.01,8.4,13.99c2.08,6.04-.3,6.08.69,12.05.68,5.99,3.58,6.23,3.87,12.42-.02,6.19-3.41,5.65-4.43,11.55-1.33,5.86,2.48,6.78.72,12.76-2.07,5.9-6.23,4.59-9.18,10.01-3.25,5.31,1.21,7.08-2.54,12.4-4.04,5.18-8.71,2.97-13.52,7.47Z",
    fill: "none"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "eSvLbpigY9t390_tr",
    transform: "translate(138.049995,264.225006) rotate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-138.049995,-264.225006)"
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M152.8,267.61c2.95-4.59,4.61-3.45,6.84-8.62c1.97-5.29,1.16-8.47,2.72-13.76-5.97.97-9.42-.03-15.43,1.3-5.91,1.58-4.77,3.17-10.1,5.43-5.18,2.48-6.8.69-11.96,3.52-5,3.04-2.92,5-7.2,8.56-4.1,3.73-6.7,1.68-10.69,5.76-3.77,4.24-.68,6.35-3.62,10.93-2.71,4.73-6.32,2.67-8.81,7.73-2.23,5.19,1.85,7.18.55,12.55c6.04-.72,7.91,3.1,13.83,1.53c5.81-1.81,3.82-5.22,9.27-7.27c5.32-2.26,7.39.69,12.39-2.35c4.84-3.24,2.79-5.75,7.25-9.12c4.29-3.55,6.28-1.51,10.06-5.75c3.56-4.4,1.71-6,4.88-10.45Z",
    fill: "url(#eSvLbpigY9t391-fill)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eSvLbpigY9t402)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }, _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 164.57,
    y1: 243.4,
    x2: 92.59,
    y2: 303.1,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _polyline25 || (_polyline25 = /*#__PURE__*/React.createElement("polyline", {
    points: "127.83,302.04 99.28,297.56 96.69,271.55",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _polyline26 || (_polyline26 = /*#__PURE__*/React.createElement("polyline", {
    points: "138.96,292.8 110.41,288.32 107.83,262.31",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _polyline27 || (_polyline27 = /*#__PURE__*/React.createElement("polyline", {
    points: "150.1,283.56 121.55,279.08 118.97,253.07",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _polyline28 || (_polyline28 = /*#__PURE__*/React.createElement("polyline", {
    points: "161.24,274.32 132.69,269.84 130.1,243.83",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _polyline29 || (_polyline29 = /*#__PURE__*/React.createElement("polyline", {
    points: "172.37,265.08 143.83,260.61 141.24,234.59",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _polyline30 || (_polyline30 = /*#__PURE__*/React.createElement("polyline", {
    points: "183.51,255.84 154.97,251.37 152.38,225.35",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "eSvLbpigY9t402"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.11,301.02c1.3-5.37-2.78-7.36-.55-12.55c2.48-5.06,6.09-3,8.81-7.73c2.94-4.59-.15-6.69,3.62-10.93c3.98-4.08,6.59-2.03,10.69-5.76c4.29-3.55,2.2-5.52,7.2-8.56c5.16-2.83,6.77-1.04,11.96-3.52c5.32-2.26,4.19-3.85,10.1-5.43c6.02-1.33,9.47-.34,15.43-1.3-1.56,5.28-.75,8.46-2.72,13.76-2.24,5.17-3.9,4.03-6.84,8.62-3.17,4.45-1.32,6.05-4.88,10.45-3.78,4.24-5.77,2.2-10.06,5.75-4.47,3.37-2.42,5.88-7.25,9.12-5,3.04-7.07.09-12.39,2.35-5.45,2.05-3.47,5.46-9.27,7.27-5.92,1.57-7.79-2.26-13.83-1.53Z",
    fill: "none"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "eSvLbpigY9t404_tr",
    transform: "translate(55,259.43488) rotate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-52.514997,-258.504997)"
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M57.73,244.42c-4.88-2.97-3.49-4.38-9.06-6.76-5.72-2.14-9.3-1.63-15.03-3.41.65,5.43-.69,8.46.36,13.97c1.33,5.42,3.17,4.52,5.3,9.46c2.38,4.83.28,6.16,3.05,11c3.01,4.71,5.33,2.97,8.97,7.07c3.85,3.95,1.39,6.14,5.62,10.01c4.43,3.69,6.98,1.06,11.85,4.03c5.04,2.77,2.51,5.87,7.94,8.46c5.59,2.37,8.08-1.16,13.93.38-.38-5.48,3.99-6.89,2.67-12.33-1.59-5.35-5.51-3.8-7.4-8.85-2.13-4.94,1.28-6.59-1.73-11.3-3.25-4.58-6.17-2.91-9.59-7.16-3.63-4.1-1.23-5.76-5.66-9.45-4.62-3.51-6.52-1.96-11.22-5.12Z",
    fill: "url(#eSvLbpigY9t405-fill)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eSvLbpigY9t416)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }, _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 31.76,
    y1: 232.14,
    x2: 92.79,
    y2: 301.03,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _polyline31 || (_polyline31 = /*#__PURE__*/React.createElement("polyline", {
    points: "94.09,269.28 87.13,294.64 58.16,295.14",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _polyline32 || (_polyline32 = /*#__PURE__*/React.createElement("polyline", {
    points: "84.64,258.63 77.69,283.98 48.71,284.48",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _polyline33 || (_polyline33 = /*#__PURE__*/React.createElement("polyline", {
    points: "75.2,247.96 68.24,273.32 39.27,273.82",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _polyline34 || (_polyline34 = /*#__PURE__*/React.createElement("polyline", {
    points: "65.75,237.3 58.8,262.66 29.82,263.16",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _polyline35 || (_polyline35 = /*#__PURE__*/React.createElement("polyline", {
    points: "56.31,226.64 49.35,251.99 20.38,252.49",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _polyline36 || (_polyline36 = /*#__PURE__*/React.createElement("polyline", {
    points: "46.87,215.98 39.91,241.33 10.94,241.83",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "eSvLbpigY9t416"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.66,298.63c-5.85-1.54-8.34,1.98-13.93-.38-5.43-2.59-2.89-5.69-7.94-8.46-4.87-2.97-7.42-.34-11.85-4.03-4.23-3.87-1.78-6.07-5.62-10.01-3.63-4.1-5.95-2.36-8.97-7.07-2.77-4.84-.68-6.16-3.05-11-2.13-4.95-3.97-4.04-5.3-9.46-1.05-5.5.29-8.54-.36-13.97c5.74,1.78,9.31,1.27,15.03,3.41c5.57,2.37,4.18,3.79,9.06,6.76c4.7,3.16,6.6,1.61,11.22,5.12c4.43,3.69,2.03,5.35,5.66,9.45c3.42,4.25,6.34,2.59,9.59,7.16c3.01,4.71-.4,6.36,1.73,11.3c1.88,5.04,5.8,3.5,7.4,8.85c1.32,5.44-3.05,6.84-2.67,12.33Z",
    fill: "none"
  }))))))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "eSvLbpigY9t418_to",
    transform: "translate(107.086657,102.949128)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-107.086657,-102.949128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.14,26.55l2.65-1.38v-2.75c-.01-1.28.99-2.85,2.23-3.49s2.24-.12,2.24,1.16v2.75c0,0,2.66-1.38,2.66-1.38c1.24-.64,2.25-.12,2.25,1.16s-1,2.84-2.24,3.48l-2.65,1.38v2.75c.01,1.28-.98,2.84-2.22,3.49-1.24.64-2.25.13-2.25-1.16v-2.75c0,0-2.66,1.38-2.66,1.38-1.24.64-2.25.13-2.25-1.15s1-2.85,2.24-3.49Z",
    fill: "url(#eSvLbpigY9t419-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1,90.53c-1.64,1.45-2.57,3.8-2.27,5.83.37,2.49,2.51,3.56,4.75,2.39l13.77-7.16c2.86-1.49,4.8-5.28,4.32-8.45-.47-3.15-3.19-4.55-6.01-3.08-.2.1-.4.22-.6.36-1.62-2.48-4.63-3.12-7.66-1.54-3.97,2.07-6.71,7.21-6.3,11.65Zm2.27,6.77c-1.52.79-2.97.06-3.22-1.62-.23-1.51.57-3.29,1.9-4.24.31-.21.51-.64.45-1.01-.59-3.82,1.72-8.33,5.13-10.11c2.65-1.38,5.29-.71,6.55,1.67.14.26.42.33.69.18.05-.03.1-.06.14-.1.29-.23.56-.41.83-.55c2.14-1.11,4.17-.09,4.53,2.28s-1.09,5.2-3.23,6.32L59.37,97.28",
    fill: "#ffc003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.47,39.43c0,0,0-.06.01-.09.14-1.24.92-2.51,2-3.07l13.12-6.83c1.1-.57,2.14-.23,2.59.74c0,0,0,0,0,.01.09.2.17.41.21.66l1.52,10.06c.22,1.47-.68,3.22-2,3.91L149.8,51.65c-1.33.69-2.58.06-2.8-1.41l-1.52-10.06c-.04-.24-.03-.49-.01-.74Zm15.35-8.53L147.7,37.73c-.32.17-.59.48-.76.84l8.26,1.98l6.5-9.66c-.24-.15-.56-.15-.88.02Zm-12.5,18.65c.1.67.67.95,1.27.64l13.12-6.83c.6-.31,1.01-1.11.91-1.78l-1.4-9.27-6.4,9.52c-.1.15-.23.26-.36.33s-.28.09-.4.07l-8.13-1.96l1.4,9.26Z",
    fill: "#3aa6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.41,167.86c-5.3,2.76-9.03,8.86-8.32,13.58.53,3.52,3.34,5.4,7.19,4.82c2.73,2.09,6.51.23,6.94,0c.32-.18.54-.49.59-.82s-.08-.61-.31-.7c-.61-.22-1.12-.54-1.54-.93c4.3-3.12,7-8.27,6.38-12.38-.72-4.73-5.61-6.34-10.92-3.58Zm-.74,16.78c-3.36.58-5.82-.94-6.26-3.88-.59-3.93,2.65-9.07,7.23-11.45s8.79-1.12,9.38,2.81c.55,3.65-2.17,8.35-6.33,10.94-.2.13-.37.36-.45.61-.08.26-.06.51.06.68.28.42.61.79,1.01,1.11-1.25.31-2.91.39-4.23-.71-.1-.08-.24-.12-.39-.1",
    fill: "#7dd075"
  })))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M380.66,216.5l2.65-1.38v-2.75c-.01-1.28.99-2.85,2.23-3.49s2.24-.12,2.24,1.16v2.75c0,0,2.66-1.38,2.66-1.38c1.24-.64,2.25-.12,2.25,1.16s-1,2.84-2.24,3.48l-2.65,1.38v2.75c.01,1.28-.98,2.84-2.22,3.49-1.24.64-2.25.12-2.25-1.16v-2.75c0,0-2.66,1.38-2.66,1.38-1.24.64-2.25.13-2.25-1.15s1-2.85,2.24-3.49Z",
    fill: "url(#eSvLbpigY9t423-fill)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M67.41,229.36l-1.88-.97c-.87-.45-.88-1.92-.01-3.28.43-.68,1.01-1.2,1.58-1.5s1.15-.37,1.58-.15l1.89.97l1.87-2.92c.43-.68,1.01-1.2,1.58-1.5s1.15-.37,1.59-.15c.88.45.88,1.92.01,3.28l-1.87,2.92l1.88.97c.88.45.88,1.92,0,3.28-.44.68-1.01,1.21-1.58,1.5-.57.3-1.15.37-1.58.15l-1.88-.97-1.87,2.92c-.43.68-1.01,1.2-1.58,1.5-.58.3-1.15.37-1.59.15-.88-.46-.88-1.92-.01-3.28l1.87-2.92Z",
    fill: "url(#eSvLbpigY9t424-fill)"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M321.68,47.36c1.33-.69,2.6-.06,2.82,1.43.19,1.22-.41,2.65-1.37,3.5l.24,1.61c.06.41-.18.88-.54,1.07-.37.19-.71.02-.77-.39l-.24-1.61c-1.07.21-1.97-.44-2.15-1.66-.22-1.48.68-3.25,2.02-3.94Zm.59,3.91c.61-.32,1.02-1.12.92-1.8s-.68-.97-1.29-.66c-.62.32-1.03,1.13-.93,1.81.1.67.68.96,1.3.64Z",
    fill: "#e83544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.88,46.21l-.29-1.88c-.28-1.84.85-4.04,2.51-4.9l.69-.36c1.67-.87,3.24-.07,3.52,1.77l.28,1.88c1.57-.67,3.01.12,3.28,1.88l1.02,6.74c.28,1.84-.85,4.04-2.51,4.9l-6.23,3.24c-1.67.87-3.24.07-3.52-1.77l-1.02-6.74c-.26-1.75.74-3.82,2.27-4.76Zm5.11-4.69c-.16-1.04-1.05-1.48-1.98-.99l-.69.36c-.94.49-1.57,1.72-1.42,2.76l.28,1.88l4.09-2.13-.28-1.88Zm-6.07,8.78l1.02,6.74c.16,1.04,1.04,1.49,1.98,1l6.23-3.24c.94-.49,1.56-1.73,1.41-2.76l-1.02-6.74c-.16-1.04-1.04-1.49-1.98-1l-.42.22-5.4,2.81-.42.22c-.94.49-1.57,1.72-1.42,2.77Z",
    fill: "#e83544"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeImage1);
export default __webpack_public_path__ + "static/media/home_image_1.cf5346c6b78d042cd613c53cc56b1179.svg";
export { ForwardRef as ReactComponent };